import React, { Component, useState, useEffect } from "react";
import { Container, Image, Row, Table } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
// import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import Alert from "react-s-alert";
//
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  create_and_update_restaurant,
  vendo_session_settings,
  get_notification_count,
} from "../../../store/actions/authAction";
import isEmpty from "../../../store/validation/is-Empty";
import { Button, Col, Modal } from "react-bootstrap";
import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import Media from "react-media";
// import { CustomerBusinessOverlayScreen } from "../../allOverlayScreen/vendorOverlayScreen/CustomerBusinessOverlayScreen";
import {
  Select,
  // TextField,
  FormControl,
  // IconButton,
  // FormHelperText,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import {
  get_session_automate,
  complete_all_orders_from_sessions,
} from "../../../store/actions/SessionsAction/sessionsAction";
import moment from "moment";
import { Hours_24 } from "../../../enums/GlobalEnums";
import { TableBodySeating, TableHeadSeating } from "./TableHeadSeating";
import TableBodyOrdering, { TableHeadOrdering } from "./TableHeadOrdering";
import { ExperienceSessionManagement } from "./ExperienceSessionManagement";
import { errorAlert } from "../../../function/alert";
import { amApi } from "../../../api/apiHelper";

export class CustomersBusiness extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // customerOverlayPopup: false,
      openErrorModal: false,
      actionButton: false,
      softOnboarding: false,
      onCasualDiningMaintainOrdering: false,
      onFastFoodMaintainOrdering: false,
      onMultiServiceMaintainOrdering: false,

      restaurantOpenClosed: false,
      sessionWalkinWaitlist: false,
      sessionReservation: false,
      autoAcceptWalkinWaitlist: false,
      autoAcceptReservation: false,
      walkinWaitlistOrderAhead: false,
      reservationOrderAhead: false,

      orderSettingTakeAway: false,
      orderSettingCurbsideDelivery: false,
      orderSettingDineIn: false,
      orderSettingSkipTheLine: false,
      orderSettingCatering: false,
      orderSettingHomeDelivery: false,

      autoAcceptOrderTakeAway: false,
      autoAcceptOrderCurbsideDelivery: false,
      autoAcceptOrderDineIn: false,
      autoAcceptOrderSkipTheLine: false,
      autoAcceptOrderCatering: false,
      autoAcceptOrderHomeDelivery: false,

      futureReservation: false,
      futureOrders: false,
      futureTakeAway: false,
      futureCurbSide: false,
      futureDinein: false,
      futureSkipTheLine: false,
      futureCatering: false,
      futureHomeDelivery: false,

      liveStreaming: false,
      eventSessionSettings: false,
      eventTicketSession: false,
      eventAutoAcceptSetting: false,
      scan_And_Pay: false,
      experienceManagementSpecial: false,
      experienceManagementCurated: false,

      hasSetSession: false,
      errors: {},

      session_auto: false,
      timings: "",
      sendTime: "",
      sessionData: {},
      getNewData: 0,
    };
    this.myDivToFocus = React.createRef();
  }

  sessionAutomateFun = (e, data) => {
    this.setState({
      session_auto: e,
      actionButton: true,
      sessionData: data,
    });
  };
  sessionAutomateChange = (e) => {
    this.setState({ session_auto: !this.state.session_auto });
  };
  setTimingsFun = (e, sendTime) => {
    this.setState({ timings: e, actionButton: true, sendTime: sendTime });
  };
  componentDidMount() {
    /***************************
     * @DESC Notification Count
     **************************/
    const token = this.props?.auth?.user?.accessToken;
    this.props.get_notification_count(token);

    this.setState({ getNewData: this.state.getNewData + 1 });
    if (this.props.auth.secondary_loader) {
      this.setState({
        loader: true,
      });
    }
    // if (
    //   this.props.customerBusinessOverlayData?.customer_business !== true &&
    //   this.props?.cus_busi_overlay_data?.customerBusinessActive === false
    // ) {
    //   this.setState({
    //     customerOverlayPopup: false,
    //   });
    // } else {
    //   this.setState({
    //     customerOverlayPopup: true,
    //   });
    // }
    if (!isEmpty(this.props.onboarding._id)) {
      let originalTime = moment(
        new Date().setHours(
          parseInt(
            this.props?.onboarding?.sessionSettings?.automat_time?.split(":")[0]
          ) + 5,
          parseInt(
            this.props?.onboarding?.sessionSettings?.automat_time?.split(":")[1]
          ) + 30
        )
      ).format("HH:mm");

      this.setState({
        session_auto: !isEmpty(
          this.props?.onboarding?.sessionSettings?.run_sessions_automatically
        )
          ? this.props?.onboarding?.sessionSettings?.run_sessions_automatically
          : false,
        timings: !isEmpty(originalTime) ? originalTime : "",
        sendTime: this.props?.onboarding?.sessionSettings?.automat_time || "",
        softOnboarding: !isEmpty(this.props.onboarding?.softOnboarding)
          ? this.props.onboarding?.softOnboarding
          : false,
        restaurantOpenClosed: !isEmpty(
          this.props.onboarding?.sessionSettings?.restaurant_open
        )
          ? this.props.onboarding?.sessionSettings?.restaurant_open
          : false,
        sessionWalkinWaitlist: !isEmpty(
          this.props.onboarding?.sessionSettings?.walkin_wait
        )
          ? this.props.onboarding?.sessionSettings?.walkin_wait
          : false,
        sessionReservation: !isEmpty(
          this.props.onboarding?.sessionSettings?.reservations
        )
          ? this.props.onboarding?.sessionSettings?.reservations
          : false,
        autoAcceptWalkinWaitlist: !isEmpty(
          this.props.onboarding?.autoAcceptSetting?.walkin_wait
        )
          ? this.props.onboarding?.autoAcceptSetting?.walkin_wait
          : false,
        autoAcceptReservation: !isEmpty(
          this.props.onboarding?.autoAcceptSetting?.reservations
        )
          ? this.props.onboarding?.autoAcceptSetting?.reservations
          : false,
        walkinWaitlistOrderAhead: !isEmpty(
          this.props.onboarding?.orderAheadSetting?.walkinWaitlistOrderAhead
        )
          ? this.props.onboarding?.orderAheadSetting?.walkinWaitlistOrderAhead
          : false,
        reservationOrderAhead: !isEmpty(
          this.props.onboarding?.orderAheadSetting?.reservationOrderAhead
        )
          ? this.props.onboarding?.orderAheadSetting?.reservationOrderAhead
          : false,

        onCasualDiningMaintainOrdering: !isEmpty(
          this.props.casualDiningData?.ordering?.maintain_separate_bank
        )
          ? this.props.casualDiningData?.ordering?.maintain_separate_bank?.value
          : false,
        onFastFoodMaintainOrdering: !isEmpty(
          this.props.fastFoodDiningData?.ordering?.maintain_separate_bank
        )
          ? this.props.fastFoodDiningData?.ordering?.maintain_separate_bank
              ?.value
          : false,
        onMultiServiceMaintainOrdering: !isEmpty(
          this.props.multiDiningData?.ordering?.maintain_separate_bank
        )
          ? this.props.multiDiningData?.ordering?.maintain_separate_bank?.value
          : false,

        orderSettingTakeAway: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.take_away
        )
          ? this.props.onboarding?.orderSessionSettings?.take_away
          : false,
        orderSettingCurbsideDelivery: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.curb_side
        )
          ? this.props.onboarding?.orderSessionSettings?.curb_side
          : false,
        orderSettingDineIn: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.dine_in_order
        )
          ? this.props.onboarding?.orderSessionSettings?.dine_in_order
          : false,
        orderSettingSkipTheLine: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.skip_line
        )
          ? this.props.onboarding?.orderSessionSettings?.skip_line
          : false,
        orderSettingCatering: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.catering
        )
          ? this.props.onboarding?.orderSessionSettings?.catering
          : false,
        orderSettingHomeDelivery: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.home_delivery
        )
          ? this.props.onboarding?.orderSessionSettings?.home_delivery
          : false,

        autoAcceptOrderTakeAway: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.take_away
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.take_away
          : false,
        autoAcceptOrderCurbsideDelivery: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.curb_side
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.curb_side
          : false,
        autoAcceptOrderDineIn: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.dine_in_order
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.dine_in_order
          : false,
        autoAcceptOrderSkipTheLine: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.skip_line
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.skip_line
          : false,
        autoAcceptOrderCatering: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.catering
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.catering
          : false,
        autoAcceptOrderHomeDelivery: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.home_delivery
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.home_delivery
          : false,

        eventAutoAcceptSetting: !isEmpty(
          this.props.onboarding?.eventAutoAcceptSetting?.RSVP
        )
          ? this.props.onboarding?.eventAutoAcceptSetting?.RSVP
          : false,
        eventSessionSettings: !isEmpty(
          this.props.onboarding?.eventSessionSettings?.RSVP
        )
          ? this.props.onboarding?.eventSessionSettings?.RSVP
          : false,
        eventTicketSession: !isEmpty(
          this.props.onboarding?.eventSessionSettings?.TICKET_BOOKING
        )
          ? this.props.onboarding?.eventSessionSettings?.TICKET_BOOKING
          : false,
        scan_And_Pay: !isEmpty(this.props?.onboarding?.scan_And_Pay)
          ? this.props?.onboarding?.scan_And_Pay
          : false,

        experienceManagementSpecial: !isEmpty(
          this.props?.onboarding?.experienceManagement
        )
          ? this.props?.onboarding?.experienceManagement?.special
          : false,
        experienceManagementCurated: !isEmpty(
          this.props?.onboarding?.experienceManagement
        )
          ? this.props?.onboarding?.experienceManagement?.curated
          : false,

        futureReservation: !isEmpty(
          this.props.onboarding?.future_activities?.reservation
        )
          ? this.props.onboarding?.future_activities?.reservation
          : false,
        futureOrders: !isEmpty(
          this.props.onboarding?.future_activities?.order?.value
        )
          ? this.props.onboarding?.future_activities?.order?.value
          : false,
        futureTakeAway: !isEmpty(
          this.props.onboarding?.future_activities?.order?.take_away
        )
          ? this.props.onboarding?.future_activities?.order?.take_away
          : false,
        futureCurbSide: !isEmpty(
          this.props.onboarding?.future_activities?.order?.curb_side
        )
          ? this.props.onboarding?.future_activities?.order?.curb_side
          : false,
        futureDinein: !isEmpty(
          this.props.onboarding?.future_activities?.order?.dine_in_order
        )
          ? this.props.onboarding?.future_activities?.order?.dine_in_order
          : false,
        futureSkipTheLine: !isEmpty(
          this.props.onboarding?.future_activities?.order?.skip_line
        )
          ? this.props.onboarding?.future_activities?.order?.skip_line
          : false,
        futureCatering: !isEmpty(
          this.props.onboarding?.future_activities?.order?.catering
        )
          ? this.props.onboarding?.future_activities?.order?.catering
          : false,
        futureHomeDelivery: !isEmpty(
          this.props.onboarding?.future_activities?.order?.home_delivery
        )
          ? this.props.onboarding?.future_activities?.order?.home_delivery
          : false,

        liveStreaming: !isEmpty(this.props?.onboarding?.live_streaming?.value)
          ? this.props?.onboarding?.live_streaming?.value
          : false,
        hasSetSession: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    if (
      nextProps?.onboarding?._id &&
      !isEmpty(nextProps?.onboarding?.sessionSettings) &&
      !isEmpty(nextProps?.onboarding?.autoAcceptSetting)
    ) {
      if (
        !isEmpty(nextProps?.onboarding?.sessionSettings) &&
        !isEmpty(nextProps?.onboarding?.autoAcceptSetting) &&
        !nextState.hasSetSession
      ) {
        let originalTime = moment(
          new Date().setHours(
            parseInt(
              nextProps?.onboarding?.sessionSettings?.automat_time?.split(
                ":"
              )[0]
            ) + 5,
            parseInt(
              nextProps?.onboarding?.sessionSettings?.automat_time?.split(
                ":"
              )[1]
            ) + 30
          )
        ).format("HH:mm");

        return {
          session_auto: !isEmpty(
            nextProps?.onboarding?.sessionSettings?.run_sessions_automatically
          )
            ? nextProps?.onboarding?.sessionSettings?.run_sessions_automatically
            : false,
          timings: !isEmpty(
            nextProps?.onboarding?.sessionSettings?.automat_time
          )
            ? originalTime
            : "",
          sendTime: nextProps?.onboarding?.sessionSettings?.automat_time || "",
          softOnboarding: !isEmpty(nextProps?.onboarding?.softOnboarding)
            ? nextProps?.onboarding?.softOnboarding
            : false,

          restaurantOpenClosed: !isEmpty(
            nextProps?.onboarding?.sessionSettings?.restaurant_open
          )
            ? nextProps?.onboarding?.sessionSettings?.restaurant_open
            : false,
          sessionWalkinWaitlist: !isEmpty(
            nextProps?.onboarding?.sessionSettings?.walkin_wait
          )
            ? nextProps?.onboarding?.sessionSettings?.walkin_wait
            : false,
          sessionReservation: !isEmpty(
            nextProps?.onboarding?.sessionSettings?.reservations
          )
            ? nextProps?.onboarding?.sessionSettings?.reservations
            : false,
          autoAcceptWalkinWaitlist: !isEmpty(
            nextProps?.onboarding?.autoAcceptSetting?.walkin_wait
          )
            ? nextProps?.onboarding?.autoAcceptSetting?.walkin_wait
            : false,
          autoAcceptReservation: !isEmpty(
            nextProps?.onboarding?.autoAcceptSetting?.reservations
          )
            ? nextProps?.onboarding?.autoAcceptSetting?.reservations
            : false,
          walkinWaitlistOrderAhead: !isEmpty(
            nextProps?.onboarding?.orderAheadSetting?.walkinWaitlistOrderAhead
          )
            ? nextProps?.onboarding?.orderAheadSetting?.walkinWaitlistOrderAhead
            : false,
          reservationOrderAhead: !isEmpty(
            nextProps?.onboarding?.orderAheadSetting?.reservationOrderAhead
          )
            ? nextProps?.onboarding?.orderAheadSetting?.reservationOrderAhead
            : false,
          onCasualDiningMaintainOrdering: !isEmpty(
            nextProps?.casualDiningData?.ordering?.maintain_separate_bank
          )
            ? nextProps?.casualDiningData?.ordering?.maintain_separate_bank
                ?.value
            : false,
          onFastFoodMaintainOrdering: !isEmpty(
            nextProps?.fastFoodDiningData?.ordering?.maintain_separate_bank
          )
            ? nextProps?.fastFoodDiningData?.ordering?.maintain_separate_bank
                ?.value
            : false,
          onMultiServiceMaintainOrdering: !isEmpty(
            nextProps?.multiDiningData?.ordering?.maintain_separate_bank?.value
          )
            ? nextProps?.multiDiningData?.ordering?.maintain_separate_bank
                ?.value
            : false,

          orderSettingTakeAway: !isEmpty(
            nextProps?.onboarding?.orderSessionSettings?.take_away
          )
            ? nextProps?.onboarding?.orderSessionSettings?.take_away
            : false,
          orderSettingCurbsideDelivery: !isEmpty(
            nextProps?.onboarding?.orderSessionSettings?.curb_side
          )
            ? nextProps?.onboarding?.orderSessionSettings?.curb_side
            : false,
          orderSettingDineIn: !isEmpty(
            nextProps?.onboarding?.orderSessionSettings?.dine_in_order
          )
            ? nextProps?.onboarding?.orderSessionSettings?.dine_in_order
            : false,
          orderSettingSkipTheLine: !isEmpty(
            nextProps?.onboarding?.orderSessionSettings?.skip_line
          )
            ? nextProps?.onboarding?.orderSessionSettings?.skip_line
            : false,
          orderSettingCatering: !isEmpty(
            nextProps?.onboarding?.orderSessionSettings?.catering
          )
            ? nextProps?.onboarding?.orderSessionSettings?.catering
            : false,
          orderSettingHomeDelivery: !isEmpty(
            nextProps?.onboarding?.orderSessionSettings?.home_delivery
          )
            ? nextProps?.onboarding?.orderSessionSettings?.home_delivery
            : false,

          autoAcceptOrderTakeAway: !isEmpty(
            nextProps?.onboarding?.orderAutoAcceptSetting?.take_away
          )
            ? nextProps?.onboarding?.orderAutoAcceptSetting?.take_away
            : false,
          autoAcceptOrderCurbsideDelivery: !isEmpty(
            nextProps?.onboarding?.orderAutoAcceptSetting?.curb_side
          )
            ? nextProps?.onboarding?.orderAutoAcceptSetting?.curb_side
            : false,
          autoAcceptOrderDineIn: !isEmpty(
            nextProps?.onboarding?.orderAutoAcceptSetting?.dine_in_order
          )
            ? nextProps?.onboarding?.orderAutoAcceptSetting?.dine_in_order
            : false,
          autoAcceptOrderSkipTheLine: !isEmpty(
            nextProps?.onboarding?.orderAutoAcceptSetting?.skip_line
          )
            ? nextProps?.onboarding?.orderAutoAcceptSetting?.skip_line
            : false,
          autoAcceptOrderCatering: !isEmpty(
            nextProps?.onboarding?.orderAutoAcceptSetting?.catering
          )
            ? nextProps?.onboarding?.orderAutoAcceptSetting?.catering
            : false,
          autoAcceptOrderHomeDelivery: !isEmpty(
            nextProps?.onboarding?.orderAutoAcceptSetting?.home_delivery
          )
            ? nextProps?.onboarding?.orderAutoAcceptSetting?.home_delivery
            : false,

          eventAutoAcceptSetting: !isEmpty(
            nextProps?.onboarding?.eventAutoAcceptSetting?.RSVP
          )
            ? nextProps?.onboarding?.eventAutoAcceptSetting?.RSVP
            : false,
          eventSessionSettings: !isEmpty(
            nextProps?.onboarding?.eventSessionSettings?.RSVP
          )
            ? nextProps?.onboarding?.eventSessionSettings?.RSVP
            : false,
          eventTicketSession: !isEmpty(
            nextProps.onboarding?.eventSessionSettings?.TICKET_BOOKING
          )
            ? nextProps.onboarding?.eventSessionSettings?.TICKET_BOOKING
            : false,
          scan_And_Pay: !isEmpty(nextProps?.onboarding?.scan_And_Pay)
            ? nextProps?.onboarding?.scan_And_Pay
            : false,

          experienceManagementSpecial: !isEmpty(
            nextProps?.onboarding?.experienceManagement
          )
            ? nextProps?.onboarding?.experienceManagement?.special
            : false,
          experienceManagementCurated: !isEmpty(
            nextProps?.onboarding?.experienceManagement
          )
            ? nextProps?.onboarding?.experienceManagement?.curated
            : false,

          futureReservation: !isEmpty(
            nextProps?.onboarding?.future_activities?.reservation
          )
            ? nextProps?.onboarding?.future_activities?.reservation
            : false,
          futureOrders: !isEmpty(
            nextProps?.onboarding?.future_activities?.order?.value
          )
            ? nextProps?.onboarding?.future_activities?.order?.value
            : false,
          futureTakeAway: !isEmpty(
            nextProps?.onboarding?.future_activities?.order?.take_away
          )
            ? nextProps?.onboarding?.future_activities?.order?.take_away
            : false,
          futureCurbSide: !isEmpty(
            nextProps?.onboarding?.future_activities?.order?.curb_side
          )
            ? nextProps?.onboarding?.future_activities?.order?.curb_side
            : false,
          futureDinein: !isEmpty(
            nextProps?.onboarding?.future_activities?.order?.dine_in_order
          )
            ? nextProps?.onboarding?.future_activities?.order?.dine_in_order
            : false,
          futureSkipTheLine: !isEmpty(
            nextProps?.onboarding?.future_activities?.order?.skip_line
          )
            ? nextProps?.onboarding?.future_activities?.order?.skip_line
            : false,
          futureCatering: !isEmpty(
            nextProps?.onboarding?.future_activities?.order?.catering
          )
            ? nextProps?.onboarding?.future_activities?.order?.catering
            : false,
          futureHomeDelivery: !isEmpty(
            nextProps?.onboarding?.future_activities?.order?.home_delivery
          )
            ? nextProps?.onboarding?.future_activities?.order?.home_delivery
            : false,

          liveStreaming: !isEmpty(nextProps?.onboarding?.live_streaming?.value)
            ? nextProps?.onboarding?.live_streaming?.value
            : false,

          hasSetSession: true,
        };
      }
    }
    if (nextProps.auth.secondary_loader !== nextState.loader) {
      return {
        loader: nextProps?.auth?.secondary_loader,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (
      !isEmpty(this.props.onboarding._id) &&
      prevProps.onboarding._id !== this.props.onboarding._id
    ) {
      let originalTime = moment(
        new Date().setHours(
          parseInt(
            this.props?.onboarding?.sessionSettings?.automat_time?.split(":")[0]
          ) + 5,
          parseInt(
            this.props?.onboarding?.sessionSettings?.automat_time?.split(":")[1]
          ) + 30
        )
      ).format("HH:mm");

      this.setState({
        session_auto: !isEmpty(
          this.props?.onboarding?.sessionSettings?.run_sessions_automatically
        )
          ? this.props?.onboarding?.sessionSettings?.run_sessions_automatically
          : false,
        timings: !isEmpty(originalTime) ? originalTime : "",
        sendTime: this.props?.onboarding?.sessionSettings?.automat_time || "",
        softOnboarding: !isEmpty(this.props?.onboarding?.softOnboarding)
          ? this.props?.onboarding?.softOnboarding
          : false,
        restaurantOpenClosed: !isEmpty(
          this.props.onboarding?.sessionSettings?.restaurant_open
        )
          ? this.props.onboarding?.sessionSettings?.restaurant_open
          : false,
        sessionWalkinWaitlist: !isEmpty(
          this.props.onboarding?.sessionSettings?.walkin_wait
        )
          ? this.props.onboarding?.sessionSettings?.walkin_wait
          : false,
        sessionReservation: !isEmpty(
          this.props.onboarding?.sessionSettings?.reservations
        )
          ? this.props.onboarding?.sessionSettings?.reservations
          : false,
        autoAcceptWalkinWaitlist: !isEmpty(
          this.props.onboarding?.autoAcceptSetting?.walkin_wait
        )
          ? this.props.onboarding?.autoAcceptSetting?.walkin_wait
          : false,
        autoAcceptReservation: !isEmpty(
          this.props.onboarding?.autoAcceptSetting?.reservations
        )
          ? this.props.onboarding?.autoAcceptSetting?.reservations
          : false,
        walkinWaitlistOrderAhead: !isEmpty(
          this.props.onboarding?.orderAheadSetting?.walkinWaitlistOrderAhead
        )
          ? this.props.onboarding?.orderAheadSetting?.walkinWaitlistOrderAhead
          : false,
        reservationOrderAhead: !isEmpty(
          this.props.onboarding?.orderAheadSetting?.reservationOrderAhead
        )
          ? this.props.onboarding?.orderAheadSetting?.reservationOrderAhead
          : false,

        onCasualDiningMaintainOrdering: !isEmpty(
          this.props.casualDiningData?.ordering?.maintain_separate_bank
        )
          ? this.props.casualDiningData?.ordering?.maintain_separate_bank?.value
          : false,
        onFastFoodMaintainOrdering: !isEmpty(
          this.props.fastFoodDiningData?.ordering?.maintain_separate_bank
        )
          ? this.props.fastFoodDiningData?.ordering?.maintain_separate_bank
              ?.value
          : false,
        onMultiServiceMaintainOrdering: !isEmpty(
          this.props.multiDiningData?.ordering?.maintain_separate_bank
        )
          ? this.props.multiDiningData?.ordering?.maintain_separate_bank?.value
          : false,

        orderSettingTakeAway: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.take_away
        )
          ? this.props.onboarding?.orderSessionSettings?.take_away
          : false,
        orderSettingCurbsideDelivery: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.curb_side
        )
          ? this.props.onboarding?.orderSessionSettings?.curb_side
          : false,
        orderSettingDineIn: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.dine_in_order
        )
          ? this.props.onboarding?.orderSessionSettings?.dine_in_order
          : false,
        orderSettingSkipTheLine: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.skip_line
        )
          ? this.props.onboarding?.orderSessionSettings?.skip_line
          : false,
        orderSettingCatering: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.catering
        )
          ? this.props.onboarding?.orderSessionSettings?.catering
          : false,
        orderSettingHomeDelivery: !isEmpty(
          this.props.onboarding?.orderSessionSettings?.home_delivery
        )
          ? this.props.onboarding?.orderSessionSettings?.home_delivery
          : false,

        autoAcceptOrderTakeAway: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.take_away
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.take_away
          : false,
        autoAcceptOrderCurbsideDelivery: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.curb_side
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.curb_side
          : false,
        autoAcceptOrderDineIn: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.dine_in_order
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.dine_in_order
          : false,
        autoAcceptOrderSkipTheLine: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.skip_line
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.skip_line
          : false,
        autoAcceptOrderCatering: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.catering
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.catering
          : false,
        autoAcceptOrderHomeDelivery: !isEmpty(
          this.props.onboarding?.orderAutoAcceptSetting?.home_delivery
        )
          ? this.props.onboarding?.orderAutoAcceptSetting?.home_delivery
          : false,

        eventAutoAcceptSetting: !isEmpty(
          this.props.onboarding?.eventAutoAcceptSetting?.RSVP
        )
          ? this.props.onboarding?.eventAutoAcceptSetting?.RSVP
          : false,
        eventSessionSettings: !isEmpty(
          this.props.onboarding?.eventSessionSettings?.RSVP
        )
          ? this.props.onboarding?.eventSessionSettings?.RSVP
          : false,
        eventTicketSession: !isEmpty(
          this.props.onboarding?.eventSessionSettings?.TICKET_BOOKING
        )
          ? this.props.onboarding?.eventSessionSettings?.TICKET_BOOKING
          : false,
        scan_And_Pay: !isEmpty(this.props?.onboarding?.scan_And_Pay)
          ? this.props?.onboarding?.scan_And_Pay
          : false,

        experienceManagementSpecial: !isEmpty(
          this.props?.onboarding?.experienceManagement
        )
          ? this.props?.onboarding?.experienceManagement?.special
          : false,
        experienceManagementCurated: !isEmpty(
          this.props?.onboarding?.experienceManagement
        )
          ? this.props?.onboarding?.experienceManagement?.curated
          : false,

        futureReservation: !isEmpty(
          this.props.onboarding?.future_activities?.reservation
        )
          ? this.props.onboarding?.future_activities?.reservation
          : false,
        futureOrders: !isEmpty(
          this.props.onboarding?.future_activities?.order?.value
        )
          ? this.props.onboarding?.future_activities?.order?.value
          : false,
        futureTakeAway: !isEmpty(
          this.props.onboarding?.future_activities?.order?.take_away
        )
          ? this.props.onboarding?.future_activities?.order?.take_away
          : false,
        futureCurbSide: !isEmpty(
          this.props.onboarding?.future_activities?.order?.curb_side
        )
          ? this.props.onboarding?.future_activities?.order?.curb_side
          : false,
        futureDinein: !isEmpty(
          this.props.onboarding?.future_activities?.order?.dine_in_order
        )
          ? this.props.onboarding?.future_activities?.order?.dine_in_order
          : false,
        futureSkipTheLine: !isEmpty(
          this.props.onboarding?.future_activities?.order?.skip_line
        )
          ? this.props.onboarding?.future_activities?.order?.skip_line
          : false,
        futureCatering: !isEmpty(
          this.props.onboarding?.future_activities?.order?.catering
        )
          ? this.props.onboarding?.future_activities?.order?.catering
          : false,
        futureHomeDelivery: !isEmpty(
          this.props.onboarding?.future_activities?.order?.home_delivery
        )
          ? this.props.onboarding?.future_activities?.order?.home_delivery
          : false,

        liveStreaming: !isEmpty(this.props?.onboarding?.live_streaming?.value)
          ? this.props?.onboarding?.live_streaming?.value
          : false,
        hasSetSession: true,
      });
    }
  }

  // handleCloseOverlay = (e) => {
  //   this.setState({
  //     customerOverlayPopup: false,
  //   });
  // };

  // onClickScrollWindow = (e) => {
  //   //.current is verification that your element has rendered
  //   console.log("Hiiiiiiiiii=>");
  //   // window.scrollTo({
  //   //   bottom: 0,
  //   //   behavior: "smooth",
  //   // });
  //   // this.handleCloseOverlay();
  //   if (this.myDivToFocus.current) {
  //     this.myDivToFocus.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //     });
  //   }
  // };

  handleShowclose = (e) => {
    this.setState({
      openErrorModal: !this.state.openErrorModal,
    });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  onphoneChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
    });
  };

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  onClickRestaurantOpenClosed = (e) => {
    let casualDiningMaintainBank =
      this.props.casualDiningData?.ordering?.maintain_separate_bank?.value;
    let fastFoodDiningMaintainBank =
      this.props.fastFoodDiningData?.ordering?.maintain_separate_bank?.value;
    let multiDiningMaintainBank =
      this.props.multiDiningData?.ordering?.maintain_separate_bank?.value;
    let allSubscription = this.props?.subscriptionStatus;

    if (!this.state.restaurantOpenClosed && this.state.softOnboarding) {
      this.setState({
        restaurantOpenClosed: !this.state.restaurantOpenClosed,
        experienceManagementSpecial: !this.state.experienceManagementSpecial,
        experienceManagementCurated: !this.state.experienceManagementCurated,
        actionButton: true,
      });
    } else if (this.state.restaurantOpenClosed) {
      this.setState({
        restaurantOpenClosed: !this.state.restaurantOpenClosed,
        sessionWalkinWaitlist: false,
        sessionReservation: false,
        orderSettingTakeAway: false,
        orderSettingCurbsideDelivery: false,
        orderSettingDineIn: false,
        orderSettingSkipTheLine: false,
        orderSettingCatering: false,
        orderSettingHomeDelivery: false,
        autoAcceptWalkinWaitlist: false,
        autoAcceptReservation: false,
        walkinWaitlistOrderAhead: false,
        reservationOrderAhead: false,
        autoAcceptOrderTakeAway: false,
        autoAcceptOrderCurbsideDelivery: false,
        autoAcceptOrderDineIn: false,
        autoAcceptOrderSkipTheLine: false,
        autoAcceptOrderCatering: false,
        autoAcceptOrderHomeDelivery: false,
        futureReservation: false,
        futureOrders: false,
        futureTakeAway: false,
        futureCurbSide: false,
        futureDinein: false,
        futureSkipTheLine: false,
        futureCatering: false,
        futureHomeDelivery: false,
        liveStreaming: false,
        eventSessionSettings: false,
        eventTicketSession: false,
        eventAutoAcceptSetting: false,
        scan_And_Pay: false,
        experienceManagementSpecial: false,
        experienceManagementCurated: false,
        actionButton: true,
      });
    } else if (
      !this.state.restaurantOpenClosed &&
      !casualDiningMaintainBank &&
      !fastFoodDiningMaintainBank &&
      !multiDiningMaintainBank
    ) {
      this.setState({
        // openErrorModal: true,
        restaurantOpenClosed: !this.state.restaurantOpenClosed,
        /************** @DESC SEATING STATUS **************/
        sessionWalkinWaitlist: allSubscription?.seating?.walkin_waitlist?.value
          ? true
          : false,
        sessionReservation: allSubscription?.seating?.reservation?.value
          ? true
          : false,
        autoAcceptWalkinWaitlist: allSubscription?.seating?.walkin_waitlist
          ?.auto_accept?.value
          ? true
          : false,
        autoAcceptReservation: allSubscription?.seating?.reservation
          ?.auto_accept?.value
          ? true
          : false,
        futureReservation: allSubscription?.seating?.reservation
          ?.same_day_reservation
          ? true
          : false,
        walkinWaitlistOrderAhead: allSubscription?.seating?.walkin_waitlist
          ?.order_ahead
          ? true
          : false,
        reservationOrderAhead: allSubscription?.seating?.reservation
          ?.order_ahead
          ? true
          : false,
        /************** @DESC ORDERING STATUS **************/
        orderSettingTakeAway: false,
        orderSettingCurbsideDelivery: false,
        orderSettingDineIn: false,
        orderSettingSkipTheLine: false,
        orderSettingCatering: false,
        orderSettingHomeDelivery: false,
        autoAcceptOrderTakeAway: false,
        autoAcceptOrderCurbsideDelivery: false,
        autoAcceptOrderDineIn: false,
        autoAcceptOrderSkipTheLine: false,
        autoAcceptOrderCatering: false,
        autoAcceptOrderHomeDelivery: false,
        futureOrders: false,
        futureTakeAway: false,
        futureCurbSide: false,
        futureDinein: false,
        futureSkipTheLine: false,
        futureCatering: false,
        futureHomeDelivery: false,
        /************** @DESC EVENT STATUS **************/
        eventSessionSettings: allSubscription?.event_management?.offline_event
          ?.rsvp?.value
          ? true
          : false,
        eventTicketSession: allSubscription?.event_management?.offline_event
          ?.booking_enabled?.value
          ? true
          : false,
        eventAutoAcceptSetting: allSubscription?.event_management?.offline_event
          ?.rsvp?.value
          ? true
          : false,
        /************** @DESC LIVE STREAMING STATUS **************/
        liveStreaming: allSubscription?.live_streaming?.value ? true : false,
        /************** @DESC SCAN AND PAY STATUS **************/
        scan_And_Pay: allSubscription?.scan_and_pay?.value ? true : false,
        experienceManagementSpecial: allSubscription?.experience_management
          ?.offline_experience?.special?.value
          ? true
          : false,
        experienceManagementCurated: allSubscription?.experience_management
          ?.offline_experience?.curated?.value
          ? true
          : false,
        actionButton: true,
      });
    } else {
      this.setState({
        restaurantOpenClosed: !this.state.restaurantOpenClosed,
        /************** @DESC SEATING STATUS **************/
        sessionWalkinWaitlist: allSubscription?.seating?.walkin_waitlist?.value
          ? true
          : false,
        sessionReservation: allSubscription?.seating?.reservation?.value
          ? true
          : false,
        autoAcceptWalkinWaitlist: allSubscription?.seating?.walkin_waitlist
          ?.auto_accept?.value
          ? true
          : false,
        autoAcceptReservation: allSubscription?.seating?.reservation
          ?.auto_accept?.value
          ? true
          : false,
        futureReservation: allSubscription?.seating?.reservation
          ?.same_day_reservation
          ? true
          : false,
        walkinWaitlistOrderAhead: allSubscription?.seating?.walkin_waitlist
          ?.order_ahead
          ? true
          : false,
        reservationOrderAhead: allSubscription?.seating?.reservation
          ?.order_ahead
          ? true
          : false,
        /************** @DESC ORDERING STATUS **************/
        orderSettingTakeAway: allSubscription?.ordering?.take_away?.value
          ? true
          : false,
        orderSettingCurbsideDelivery: allSubscription?.ordering
          ?.cubside_delivery?.value
          ? true
          : false,
        orderSettingDineIn: allSubscription?.ordering?.dine_in_order?.value
          ? true
          : false,
        orderSettingSkipTheLine: allSubscription?.ordering?.self_serve?.value
          ? true
          : false,
        orderSettingCatering: allSubscription?.ordering?.catering_banquet?.value
          ? true
          : false,
        orderSettingHomeDelivery: allSubscription?.ordering?.home_delivery
          ?.value
          ? true
          : false,
        autoAcceptOrderTakeAway: allSubscription?.ordering?.take_away
          ?.auto_accept
          ? true
          : false,
        autoAcceptOrderCurbsideDelivery: allSubscription?.ordering
          ?.cubside_delivery?.auto_accept
          ? true
          : false,
        autoAcceptOrderDineIn: allSubscription?.ordering?.dine_in_order
          ?.auto_accept
          ? true
          : false,
        autoAcceptOrderSkipTheLine: allSubscription?.ordering?.self_serve
          ?.auto_accept
          ? true
          : false,
        autoAcceptOrderCatering: allSubscription?.ordering?.catering_banquet
          ?.auto_accept
          ? true
          : false,
        autoAcceptOrderHomeDelivery: allSubscription?.ordering?.home_delivery
          ?.auto_accept
          ? true
          : false,
        futureOrders:
          allSubscription?.ordering?.take_away?.order_for_future &&
          allSubscription?.ordering?.cubside_delivery?.order_for_future &&
          allSubscription?.ordering?.dine_in_order?.order_for_future &&
          allSubscription?.ordering?.self_serve?.order_for_future &&
          allSubscription?.ordering?.catering_banquet?.order_for_future &&
          allSubscription?.ordering?.home_delivery?.order_for_future
            ? true
            : false,
        futureTakeAway: allSubscription?.ordering?.take_away?.order_for_future
          ? true
          : false,
        futureCurbSide: allSubscription?.ordering?.cubside_delivery
          ?.order_for_future
          ? true
          : false,
        futureDinein: allSubscription?.ordering?.dine_in_order?.order_for_future
          ? true
          : false,
        futureSkipTheLine: allSubscription?.ordering?.self_serve
          ?.order_for_future
          ? true
          : false,
        futureCatering: allSubscription?.ordering?.catering_banquet
          ?.order_for_future
          ? true
          : false,
        futureHomeDelivery: allSubscription?.ordering?.home_delivery
          ?.order_for_future
          ? true
          : false,
        /************** @DESC EVENT STATUS **************/
        eventSessionSettings: allSubscription?.event_management?.offline_event
          ?.rsvp?.value
          ? true
          : false,
        eventTicketSession: allSubscription?.event_management?.offline_event
          ?.booking_enabled?.value
          ? true
          : false,
        eventAutoAcceptSetting: allSubscription?.event_management?.offline_event
          ?.rsvp?.value
          ? true
          : false,
        /************** @DESC LIVE STREAMING STATUS **************/
        liveStreaming: allSubscription?.live_streaming?.value ? true : false,
        /************** @DESC SCAN AND PAY STATUS **************/
        scan_And_Pay: allSubscription?.scan_and_pay?.value ? true : false,
        experienceManagementSpecial: allSubscription?.experience_management
          ?.offline_experience?.special?.value
          ? true
          : false,
        experienceManagementCurated: allSubscription?.experience_management
          ?.offline_experience?.curated?.value
          ? true
          : false,
        actionButton: true,
      });
    }
  };

  onClickSessionWalkinWaitlist = (e) => {
    this.setState({
      sessionWalkinWaitlist: !this.state?.sessionWalkinWaitlist,
      actionButton: true,
    });
  };

  onClickSessionReservation = (e) => {
    this.setState({
      sessionReservation: !this.state?.sessionReservation,
      actionButton: true,
    });
  };

  onClickAutoAcceptWalkinWaitlist = (e) => {
    this.setState({
      autoAcceptWalkinWaitlist: !this.state?.autoAcceptWalkinWaitlist,
      actionButton: true,
    });
  };

  onClickAutoAcceptReservation = (e) => {
    this.setState({
      autoAcceptReservation: !this.state?.autoAcceptReservation,
      actionButton: true,
    });
  };

  onClickOrderAheadWalkinWaitlist = (e) => {
    this.setState({
      walkinWaitlistOrderAhead: !this.state?.walkinWaitlistOrderAhead,
      actionButton: true,
    });
  };

  onClickOrderAheadReservation = (e) => {
    this.setState({
      reservationOrderAhead: !this.state?.reservationOrderAhead,
      actionButton: true,
    });
  };

  onClickOrderSettings = (action) => {
    let casualDiningMaintainBank =
      this.props.casualDiningData?.ordering?.maintain_separate_bank?.value;
    let fastFoodDiningMaintainBank =
      this.props.fastFoodDiningData?.ordering?.maintain_separate_bank?.value;
    let multiDiningMaintainBank =
      this.props.multiDiningData?.ordering?.maintain_separate_bank?.value;

    if (action === "takeAway") {
      if (this.state?.orderSettingTakeAway) {
        this.setState({
          orderSettingTakeAway: !this.state?.orderSettingTakeAway,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          orderSettingTakeAway: !this.state?.orderSettingTakeAway,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "curbside") {
      if (this.state?.orderSettingCurbsideDelivery) {
        this.setState({
          orderSettingCurbsideDelivery:
            !this.state?.orderSettingCurbsideDelivery,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          orderSettingCurbsideDelivery:
            !this.state?.orderSettingCurbsideDelivery,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "dinein") {
      if (this.state?.orderSettingDineIn) {
        this.setState({
          orderSettingDineIn: !this.state?.orderSettingDineIn,
          actionButton: true,
        });
      } else if (casualDiningMaintainBank || multiDiningMaintainBank) {
        this.setState({
          orderSettingDineIn: !this.state?.orderSettingDineIn,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "skipline") {
      if (this.state?.orderSettingSkipTheLine) {
        this.setState({
          orderSettingSkipTheLine: !this.state?.orderSettingSkipTheLine,
          actionButton: true,
        });
      } else if (fastFoodDiningMaintainBank || multiDiningMaintainBank) {
        this.setState({
          orderSettingSkipTheLine: !this.state?.orderSettingSkipTheLine,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "catering") {
      if (this.state?.orderSettingCatering) {
        this.setState({
          orderSettingCatering: !this.state?.orderSettingCatering,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          orderSettingCatering: !this.state?.orderSettingCatering,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "homeDelivery") {
      if (this.state?.orderSettingHomeDelivery) {
        this.setState({
          orderSettingHomeDelivery: !this.state?.orderSettingHomeDelivery,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          orderSettingHomeDelivery: !this.state?.orderSettingHomeDelivery,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    }
  };

  onClickAutoAcceptOrderSettings = (action) => {
    let casualDiningMaintainBank =
      this.props.casualDiningData?.ordering?.maintain_separate_bank?.value;
    let fastFoodDiningMaintainBank =
      this.props.fastFoodDiningData?.ordering?.maintain_separate_bank?.value;
    let multiDiningMaintainBank =
      this.props.multiDiningData?.ordering?.maintain_separate_bank?.value;

    if (action === "takeAway") {
      if (this.state?.autoAcceptOrderTakeAway) {
        this.setState({
          autoAcceptOrderTakeAway: !this.state?.autoAcceptOrderTakeAway,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          autoAcceptOrderTakeAway: !this.state?.autoAcceptOrderTakeAway,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "curbside") {
      if (this.state?.autoAcceptOrderCurbsideDelivery) {
        this.setState({
          autoAcceptOrderCurbsideDelivery:
            !this.state?.autoAcceptOrderCurbsideDelivery,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          autoAcceptOrderCurbsideDelivery:
            !this.state?.autoAcceptOrderCurbsideDelivery,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "dinein") {
      if (this.state?.autoAcceptOrderDineIn) {
        this.setState({
          autoAcceptOrderDineIn: !this.state?.autoAcceptOrderDineIn,
          actionButton: true,
        });
      } else if (casualDiningMaintainBank || multiDiningMaintainBank) {
        this.setState({
          autoAcceptOrderDineIn: !this.state?.autoAcceptOrderDineIn,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "skipline") {
      if (this.state?.autoAcceptOrderSkipTheLine) {
        this.setState({
          autoAcceptOrderSkipTheLine: !this.state?.autoAcceptOrderSkipTheLine,
          actionButton: true,
        });
      } else if (fastFoodDiningMaintainBank || multiDiningMaintainBank) {
        this.setState({
          autoAcceptOrderSkipTheLine: !this.state?.autoAcceptOrderSkipTheLine,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "catering") {
      if (this.state?.autoAcceptOrderCatering) {
        this.setState({
          autoAcceptOrderCatering: !this.state?.autoAcceptOrderCatering,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          autoAcceptOrderCatering: !this.state?.autoAcceptOrderCatering,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "homeDelivery") {
      if (this.state?.autoAcceptOrderHomeDelivery) {
        this.setState({
          autoAcceptOrderHomeDelivery: !this.state?.autoAcceptOrderHomeDelivery,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          autoAcceptOrderHomeDelivery: !this.state?.autoAcceptOrderHomeDelivery,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    }
  };

  onClickFutureOrderSettings = (action) => {
    let casualDiningMaintainBank =
      this.props.casualDiningData?.ordering?.maintain_separate_bank?.value;
    let fastFoodDiningMaintainBank =
      this.props.fastFoodDiningData?.ordering?.maintain_separate_bank?.value;
    let multiDiningMaintainBank =
      this.props.multiDiningData?.ordering?.maintain_separate_bank?.value;

    if (action === "futureReservation") {
      this.setState({
        futureReservation: !this.state?.futureReservation,
        actionButton: true,
      });
    } else if (action === "futureOrders") {
      if (this.state?.futureOrders) {
        this.setState({
          futureOrders: !this.state?.futureOrders,
          futureTakeAway: false,
          futureCurbSide: false,
          futureDinein: false,
          futureSkipTheLine: false,
          futureHomeDelivery: false,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          futureOrders: !this.state?.futureOrders,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "futureTakeAway") {
      if (this.state?.futureTakeAway) {
        this.setState({
          futureTakeAway: !this.state?.futureTakeAway,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          futureTakeAway: !this.state?.futureTakeAway,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "futureCurbSide") {
      if (this.state?.futureCurbSide) {
        this.setState({
          futureCurbSide: !this.state?.futureCurbSide,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          futureCurbSide: !this.state?.futureCurbSide,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "futureDinein") {
      if (this.state?.futureDinein) {
        this.setState({
          futureDinein: !this.state?.futureDinein,
          actionButton: true,
        });
      } else if (casualDiningMaintainBank || multiDiningMaintainBank) {
        this.setState({
          futureDinein: !this.state?.futureDinein,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "futureSkipTheLine") {
      if (this.state?.futureSkipTheLine) {
        this.setState({
          futureSkipTheLine: !this.state?.futureSkipTheLine,
          actionButton: true,
        });
      } else if (fastFoodDiningMaintainBank || multiDiningMaintainBank) {
        this.setState({
          futureSkipTheLine: !this.state?.futureSkipTheLine,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "futureCatering") {
      if (this.state?.futureCatering) {
        this.setState({
          futureCatering: !this.state?.futureCatering,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          futureCatering: !this.state?.futureCatering,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    } else if (action === "futureHomeDelivery") {
      if (this.state?.futureHomeDelivery) {
        this.setState({
          futureHomeDelivery: !this.state?.futureHomeDelivery,
          actionButton: true,
        });
      } else if (
        casualDiningMaintainBank ||
        fastFoodDiningMaintainBank ||
        multiDiningMaintainBank
      ) {
        this.setState({
          futureHomeDelivery: !this.state?.futureHomeDelivery,
          actionButton: true,
        });
      } else {
        this.setState({
          openErrorModal: true,
        });
      }
    }
  };

  onClickEventAutoAcceptSession = (e) => {
    this.setState({
      eventSessionSettings: !this.state?.eventSessionSettings,
      actionButton: true,
    });
  };

  onClickTicketAutoAcceptSession = (e) => {
    this.setState({
      eventTicketSession: !this.state?.eventTicketSession,
      actionButton: true,
    });
  };

  onClickEventAutoAcceptSeating = (e) => {
    this.setState({
      eventAutoAcceptSetting: !this.state?.eventAutoAcceptSetting,
      actionButton: true,
    });
  };

  onClickliveStreaming = (e) => {
    if (this.state?.liveStreaming) {
      this.setState({
        liveStreaming: false,
        actionButton: true,
      });
    } else {
      this.props.history.push("/livestreamingsession");
    }
  };

  onClickScanAndPay = (e) => {
    this.setState({
      scan_And_Pay: !this.state?.scan_And_Pay,
      actionButton: true,
    });
  };

  onClickExperience = (e, type) => {
    if (type === "SPECIAL") {
      this.setState({
        experienceManagementSpecial: !this.state.experienceManagementSpecial,
        actionButton: true,
      });
    } else if (type === "CURATED") {
      this.setState({
        experienceManagementCurated: !this.state.experienceManagementCurated,
        actionButton: true,
      });
    }
  };

  onCancelSubmit = (e) => {
    if (this.props?.subscriptionStatus?.ordering?.value) {
      this.props.history.push("/orderdashboard/10");
    } else if (this.props?.subscriptionStatus?.seating?.value) {
      this.props.history.push("/seatingdashboard");
    } else if (this.props?.subscriptionStatus?.event_management?.value) {
      this.props.history.push("/event");
    } else {
      this.props.history.push("/customerbusiness");
    }
  };

  onSubmitHandler = (e) => {
    const token = this.props?.auth?.user?.accessToken;
    e.preventDefault();
    if (this.props?.onboarding?._id) {
      const formData = {
        id: this.props?.onboarding?._id,
        vendor_id: this.props?.onboarding?.vendor_id,
        sessionSettings: {
          run_sessions_automatically: this.state.session_auto,
          automat_time: this.state?.sendTime || "",
          restaurant_open: this.state?.restaurantOpenClosed,
          walkin_wait: this.state?.sessionWalkinWaitlist,
          reservations: this.state?.sessionReservation,
        },
        autoAcceptSetting: {
          walkin_wait: this.state?.autoAcceptWalkinWaitlist,
          reservations: this.state?.autoAcceptReservation,
        },
        orderAheadSetting: {
          walkinWaitlistOrderAhead: this.state?.walkinWaitlistOrderAhead,
          reservationOrderAhead: this.state?.reservationOrderAhead,
        },
        orderSessionSettings: {
          take_away: this.state?.orderSettingTakeAway,
          curb_side: this.state?.orderSettingCurbsideDelivery,
          dine_in_order: this.state?.orderSettingDineIn,
          skip_line: this.state?.orderSettingSkipTheLine,
          catering: this.state?.orderSettingCatering,
          home_delivery: this.state?.orderSettingHomeDelivery,
        },
        orderAutoAcceptSetting: {
          take_away: this.state?.autoAcceptOrderTakeAway,
          curb_side: this.state?.autoAcceptOrderCurbsideDelivery,
          dine_in_order: this.state?.autoAcceptOrderDineIn,
          skip_line: this.state?.autoAcceptOrderSkipTheLine,
          catering: this.state?.autoAcceptOrderCatering,
          home_delivery: this.state?.autoAcceptOrderHomeDelivery,
        },
        future_activities: {
          reservation: this.state?.futureReservation,
          order: {
            value: this.state?.futureOrders,
            take_away: this.state?.futureTakeAway,
            curb_side: this.state?.futureCurbSide,
            dine_in_order: this.state?.futureDinein,
            skip_line: this.state?.futureSkipTheLine,
            catering: this.state?.futureCatering,
            home_delivery: this.state?.futureHomeDelivery,
          },
        },
        live_streaming: {
          value: this.state?.liveStreaming,
        },
        eventSessionSettings: {
          RSVP: this.state?.eventSessionSettings,
          TICKET_BOOKING: this.state?.eventTicketSession,
        },
        eventAutoAcceptSetting: {
          RSVP: this.state?.eventAutoAcceptSetting,
        },
        scan_And_Pay: this.state?.scan_And_Pay,
        experienceManagement: {
          special: this.state?.experienceManagementSpecial,
          curated: this.state?.experienceManagementCurated,
        },
      };
      this.changeStatusOfExperience(
        this.props?.onboarding?.experienceManagement
      );
      if (this.state?.restaurantOpenClosed) {
        this.props.vendo_session_settings(token, "diner");
        this.props.vendo_session_settings(token, "order");
        this.props.vendo_session_settings(token, "event-handler");
        this.props.create_and_update_restaurant(
          formData,
          (data) => this.onSuccess(data),
          (err) => this.onErrorSuccess(err)
        );
        this.setState({
          actionButton: false,
        });
      } else {
        this.props.create_and_update_restaurant(
          formData,
          (data) => this.onSuccess(data),
          (err) => this.onErrorSuccess(err)
        );
        this.setState({
          actionButton: false,
        });
      }
    }
  };

  changeStatusOfExperience = async (prevState) => {
    let flag = false;
    let formData = {};
    if (
      prevState?.special !== this.state?.experienceManagementSpecial &&
      prevState?.curated !== this.state?.experienceManagementCurated
    ) {
      flag = true;
      formData = {
        special: this.state?.experienceManagementSpecial,
        curated: this.state?.experienceManagementCurated,
      };
    } else if (prevState?.special !== this.state?.experienceManagementSpecial) {
    } else if (prevState?.special !== this.state?.experienceManagementSpecial) {
      flag = true;
      formData = {
        special: this.state?.experienceManagementSpecial,
      };
    } else if (prevState?.curated !== this.state?.experienceManagementCurated) {
    } else if (prevState?.curated !== this.state?.experienceManagementCurated) {
      flag = true;
      formData = {
        curated: this.state?.experienceManagementCurated,
      };
    }
    formData.restaurant_id = this.props?.onboarding?._id;
    if (flag) await amApi.post("/experience?type=SESSION", formData);
  };

  onSuccess = (data) => {
    Alert.success(
      `<h4>${data?.restaurant_name} session settings update successfully</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  onErrorSuccess = (err) => {
    Alert.error(`<h4>${err?.responce?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onSuccessSeating = (e) => {
    this.setState({ getNewData: this.state.getNewData + 1 });
  };

  markAllAsComplete = async (state) => {
    const token = this.props?.auth?.user?.accessToken;
    if (state === 0 && this?.state?.sessionData?.seating?.length > 0) {
      let ids = [];
      await this?.state?.sessionData?.seating?.map((data) => {
        ids.push(data._id);
      });
      complete_all_orders_from_sessions(
        token,
        "seating",
        ids,
        this.onSuccessCompleteAll
      );
    } else if (state === 1 && this?.state?.sessionData?.ordering?.length > 0) {
      let ids = [];
      await this?.state?.sessionData?.ordering?.map((data) => {
        ids.push(data._id);
      });
      complete_all_orders_from_sessions(
        token,
        "ordering",
        ids,
        this.onSuccessCompleteAll
      );
    }
  };

  onSuccessCompleteAll = (err) => {
    Alert.success(`<h4>Succssfully updated all requests</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    const token = this.props?.auth?.user?.accessToken;
    get_session_automate(token, (data) => {
      this.sessionAutomateFun(data.run_sessions_automatically, data);
    });
  };

  render() {
    try {
      if (this.state?.loader) {
        return (
          <React.Fragment>
            <AmealioLoader />
          </React.Fragment>
        );
      }
      const { actionButton, customerOverlayPopup } = this.state;
      return (
        <React.Fragment>
          <Container fluid>
            <Row>
              {/* <CustomerBusinessOverlayScreen
                show={this.state.customerOverlayPopup}
                handleClose={this.handleCloseOverlay}
                onClickScrollWindow={this.onClickScrollWindow}
              /> */}
              <Media query="(min-width: 992px)">
                <div className="left-side-panel">
                  <LeftSideNavigation />
                </div>
              </Media>
              <div
                className="right-side-panel mobile-px-15"
                // style={{ zIndex: `${customerOverlayPopup ? "1041" : ""}` }}
              >
                <RightSideNavigation
                // overlayData={customerOverlayPopup}
                />
                <div className="customer-busines-mobile-padding main-seating-dashboard-body">
                  <Row>
                    <Col lg={6}>
                      <div className="pb-5">
                        <div className="f24_700_HelveticaNeue">
                          Session Settings
                        </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <Row className="pb-4">
                        <Col>
                          <div className="f15-500">Restaurant Open / Close</div>
                        </Col>
                        <Col className="d-flex align-items-center">
                          <Media query="(max-width: 991px)">
                            <span
                              className={
                                this.state?.restaurantOpenClosed
                                  ? "f12-400 mr-2"
                                  : "f12-500 mr-2"
                              }
                            >
                              No
                            </span>
                          </Media>
                          <Toggle
                            checked={this.state?.restaurantOpenClosed}
                            toggleFunction={this.onClickRestaurantOpenClosed}
                          />
                          <Media query="(max-width: 991px)">
                            <span
                              className={
                                this.state?.restaurantOpenClosed
                                  ? "f12-500 ml-2"
                                  : "f12-400 ml-2"
                              }
                            >
                              Yes
                            </span>
                          </Media>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {/* Web settings */}
                  <Media query="(min-width: 992px)">
                    <Row>
                      <Col lg={12}>
                        {this.props.casualDiningData?.seating?.value ||
                        this.props.multiDiningData?.seating?.value ? (
                          <Row>
                            <Col></Col>
                            <Col>
                              <div className="f20-700 mb-4">On/Off</div>
                            </Col>
                            <Col className="f18-700 ">
                              Auto Accept <br /> Seating
                            </Col>
                            <Col className="f18-700 ">
                              Future Activities
                              <p className="f14-400 mb-4 color-gray">
                                {" "}
                                Manage accepting request from the next day
                              </p>
                            </Col>
                            <Col className="f18-700 ">Order Ahead</Col>
                          </Row>
                        ) : null}

                        {this.props.casualDiningData?.seating?.walkin_waitlist
                          ?.value ||
                        this.props.multiDiningData?.seating?.walkin_waitlist
                          ?.value ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500">Walk-In / Wait</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.sessionWalkinWaitlist}
                                toggleFunction={
                                  this.onClickSessionWalkinWaitlist
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.autoAcceptWalkinWaitlist}
                                toggleFunction={
                                  this.onClickAutoAcceptWalkinWaitlist
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col></Col>
                            <Col>
                              {this.props.casualDiningData?.seating
                                ?.walkin_waitlist?.order_ahead ||
                              this.props.multiDiningData?.seating
                                ?.walkin_waitlist?.order_ahead ? (
                                <Toggle
                                  checked={this.state?.walkinWaitlistOrderAhead}
                                  toggleFunction={
                                    this.onClickOrderAheadWalkinWaitlist
                                  }
                                  disabled={
                                    this.state.softOnboarding ? true : false
                                  }
                                />
                              ) : null}
                            </Col>
                          </Row>
                        ) : null}

                        {(this.props.casualDiningData?.seating?.reservation
                          ?.value &&
                          this.props.casualDiningData?.seating?.reservation
                            ?.same_day_reservation) ||
                        (this.props.multiDiningData?.seating?.reservation
                          ?.value &&
                          this.props.multiDiningData?.seating?.reservation
                            ?.same_day_reservation) ? (
                          <Row
                            className={`${
                              this.props.cus_busi_overlay_data
                                ?.customerBusinessCount === 2
                                ? "bg-white py-4"
                                : "pb-4"
                            }`}
                            style={{ alignItems: "center" }}
                          >
                            <Col>
                              <div className="f15-500 pb-1">Reservation</div>
                              <div className="f14-400 mb-4 color-gray">
                                Reservations for a later time, today, can be
                                placed by the guest
                              </div>
                            </Col>
                            <Col
                              className="d-flex"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.sessionReservation}
                                toggleFunction={this.onClickSessionReservation}
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.autoAcceptReservation}
                                toggleFunction={
                                  this.onClickAutoAcceptReservation
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.futureReservation}
                                toggleFunction={
                                  // this.props.subscriptionData?.this.props.subscriptionData.casual_dining_status
                                  (e) =>
                                    this.onClickFutureOrderSettings(
                                      "futureReservation"
                                    )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col>
                              {this.props.casualDiningData?.seating?.reservation
                                ?.order_ahead ||
                              this.props.multiDiningData?.seating?.reservation
                                ?.order_ahead ? (
                                <Toggle
                                  checked={this.state?.reservationOrderAhead}
                                  toggleFunction={
                                    this.onClickOrderAheadReservation
                                  }
                                  disabled={
                                    this.state.softOnboarding ? true : false
                                  }
                                />
                              ) : null}
                            </Col>
                          </Row>
                        ) : null}
                      </Col>

                      {this.props.casualDiningData?.seating?.value ||
                      this.props.multiDiningData?.seating?.value ? (
                        <Col md={12}>
                          <hr className="mb-4" />
                        </Col>
                      ) : null}
                      <Col lg={12}>
                        <Row>
                          <Col></Col>
                          <Col
                            className="d-flex align-items-center mb-4"
                            // style={{
                            //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                            // }}
                          >
                            <div className="f20-700 mb-4">On/Off</div>
                          </Col>
                          <Col className="f18-700 mb-4">
                            Auto Accept <br /> Order
                          </Col>
                          <Col className="f18-700 mb-4">Future Activities</Col>
                        </Row>

                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering?.take_away
                            ?.value) ||
                        (this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering?.take_away
                            ?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.take_away
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500">Take Away</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.orderSettingTakeAway}
                                toggleFunction={(e) =>
                                  this.onClickOrderSettings("takeAway")
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.autoAcceptOrderTakeAway}
                                toggleFunction={(e) =>
                                  this.onClickAutoAcceptOrderSettings(
                                    "takeAway"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.futureTakeAway}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureTakeAway"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering
                            ?.cubside_delivery?.value) ||
                        (this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering
                            ?.cubside_delivery?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.cubside_delivery
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500">Curbside Delivery</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={
                                  this.state?.orderSettingCurbsideDelivery
                                }
                                toggleFunction={(e) =>
                                  this.onClickOrderSettings("curbside")
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={
                                  this.state?.autoAcceptOrderCurbsideDelivery
                                }
                                toggleFunction={(e) =>
                                  this.onClickAutoAcceptOrderSettings(
                                    "curbside"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.futureCurbSide}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureCurbSide"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering?.dine_in_order
                            ?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.dine_in_order
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500 pb-1">
                                Dine-In / Order Ahead
                              </div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.orderSettingDineIn}
                                toggleFunction={(e) =>
                                  this.onClickOrderSettings("dinein")
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.autoAcceptOrderDineIn}
                                toggleFunction={(e) =>
                                  this.onClickAutoAcceptOrderSettings("dinein")
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.futureDinein}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureDinein"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                          </Row>
                        ) : null}

                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering
                            ?.catering_banquet?.value) ||
                        (this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering
                            ?.catering_banquet?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.catering_banquet
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500">Catering</div>
                            </Col>
                            <Col className="d-flex align-items-center">
                              <Toggle
                                checked={this.state?.orderSettingCatering}
                                toggleFunction={(e) =>
                                  this.onClickOrderSettings("catering")
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col className="d-flex align-items-center">
                              <Toggle
                                checked={this.state?.autoAcceptOrderCatering}
                                toggleFunction={(e) =>
                                  this.onClickAutoAcceptOrderSettings(
                                    "catering"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col className="d-flex align-items-center">
                              <Toggle
                                checked={this.state?.futureCatering}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureCatering"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering?.home_delivery
                            ?.value) ||
                        (this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering?.home_delivery
                            ?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.home_delivery
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500">Home Delivery</div>
                            </Col>
                            <Col className="d-flex align-items-center">
                              <Toggle
                                checked={this.state?.orderSettingHomeDelivery}
                                toggleFunction={(e) =>
                                  this.onClickOrderSettings("homeDelivery")
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col className="d-flex align-items-center">
                              <Toggle
                                checked={
                                  this.state?.autoAcceptOrderHomeDelivery
                                }
                                toggleFunction={(e) =>
                                  this.onClickAutoAcceptOrderSettings(
                                    "homeDelivery"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding
                                    ? true
                                    : this.props?.deliveryPartner === 2
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                            <Col className="d-flex align-items-center">
                              <Toggle
                                checked={this.state?.futureHomeDelivery}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureHomeDelivery"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding
                                    ? true
                                    : this.props?.deliveryPartner === 2
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering.self_serve
                            .value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering.self_serve
                            .value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500 pb-1">Skip the Line</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.orderSettingSkipTheLine}
                                toggleFunction={(e) =>
                                  this.onClickOrderSettings("skipline")
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.autoAcceptOrderSkipTheLine}
                                toggleFunction={(e) =>
                                  this.onClickAutoAcceptOrderSettings(
                                    "skipline"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.futureSkipTheLine}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureSkipTheLine"
                                  )
                                }
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                          </Row>
                        ) : null}
                      </Col>

                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.event_management?.value &&
                        this.props.casualDiningData?.event_management
                          ?.offline_event?.value &&
                        this.props.casualDiningData?.event_management
                          ?.offline_event?.rsvp?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.event_management?.value &&
                        this.props.multiDiningData?.event_management
                          ?.offline_event?.value &&
                        this.props.multiDiningData?.event_management
                          ?.offline_event?.rsvp?.value) ? (
                        <Col md={12}>
                          <hr className="mb-4" />
                        </Col>
                      ) : (
                        ""
                      )}
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.event_management?.value &&
                        this.props.casualDiningData?.event_management
                          ?.offline_event?.value &&
                        this.props.casualDiningData?.event_management
                          ?.offline_event?.rsvp?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.event_management?.value &&
                        this.props.multiDiningData?.event_management
                          ?.offline_event?.value &&
                        this.props.multiDiningData?.event_management
                          ?.offline_event?.rsvp?.value) ? (
                        <div className="col-12">
                          <Row>
                            <Col lg={12}>
                              <Row>
                                <Col>
                                  <div className="f20-700 mb-4">
                                    Event Session Settings
                                  </div>
                                </Col>
                                <Col></Col>
                                {(this.props.casualDiningData?.event_management
                                  ?.offline_event?.booking_enabled?.value ||
                                  this.props.multiDiningData?.event_management
                                    ?.offline_event?.booking_enabled
                                    ?.value) && (
                                  <>
                                    <Col></Col>
                                  </>
                                )}
                                <Col className="f18-700 mb-4">Auto Accept</Col>
                                <Col></Col>
                                <Col></Col>
                              </Row>
                              <Row className="pb-4">
                                <Col>
                                  <div className="f15-500">RSVP</div>
                                </Col>
                                <Col
                                  className="d-flex align-items-center"
                                  // style={{
                                  //   opacity: `${
                                  //     customerOverlayPopup ? "0.3" : ""
                                  //   }`,
                                  // }}
                                >
                                  <Toggle
                                    checked={this.state?.eventSessionSettings}
                                    toggleFunction={
                                      this.onClickEventAutoAcceptSession
                                    }
                                    disabled={
                                      this.state.softOnboarding ? true : false
                                    }
                                  />
                                </Col>

                                <Col className="d-flex align-items-center">
                                  <Toggle
                                    checked={this.state?.eventAutoAcceptSetting}
                                    toggleFunction={
                                      this.onClickEventAutoAcceptSeating
                                    }
                                    disabled={
                                      this.state.softOnboarding ? true : false
                                    }
                                  />
                                </Col>
                                <Col></Col>
                              </Row>
                              {(this.props.casualDiningData?.event_management
                                ?.offline_event?.booking_enabled?.value ||
                                this.props.multiDiningData?.event_management
                                  ?.offline_event?.booking_enabled?.value) && (
                                <Row>
                                  <Col>
                                    <div className="f15-500">
                                      Ticket Booking
                                    </div>
                                  </Col>
                                  <Col className="d-flex align-items-center">
                                    <Toggle
                                      checked={this.state?.eventTicketSession}
                                      toggleFunction={
                                        this.onClickTicketAutoAcceptSession
                                      }
                                      disabled={
                                        this.state.softOnboarding ? true : false
                                      }
                                    />
                                  </Col>
                                  <Col></Col>
                                  <Col></Col>
                                </Row>
                              )}
                            </Col>
                            <Col lg={12} style={{ display: "none" }}>
                              <div className="f20-700 mb-4">
                                Event Auto Accept Seating
                              </div>
                              {/* {this.props.subscriptionData &&
                        this.props.subscriptionData.casual_dining === true &&
                        this.props.subscriptionData.casual_dining_status.seating
                          .walkin_waitlist.auto_accept.value === true ? ( */}
                              <Row className="pb-4">
                                <Col>
                                  <div className="f15-500">RSVP</div>
                                </Col>
                                <Col
                                  className="d-flex align-items-center"
                                  // style={{
                                  //   opacity: `${
                                  //     customerOverlayPopup ? "0.3" : ""
                                  //   }`,
                                  // }}
                                >
                                  <Toggle
                                    checked={this.state?.eventAutoAcceptSetting}
                                    toggleFunction={
                                      this.onClickEventAutoAcceptSeating
                                    }
                                    disabled={
                                      this.state.softOnboarding ? true : false
                                    }
                                  />
                                </Col>
                              </Row>
                              {/* ) : null} */}
                            </Col>
                          </Row>
                        </div>
                      ) : null}
                      <Col md={12}>
                        <hr className="mb-4" />
                      </Col>
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.live_streaming?.value) ||
                      (this.props.fastFoodDiningService &&
                        this.props.fastFoodDiningData?.live_streaming?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.live_streaming?.value) ? (
                        <Col md={6} ref={this.myDivToFocus}>
                          <Row className="py-2">
                            <Col>
                              <div className="f20-700 mb-4">Live Streaming</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.liveStreaming}
                                toggleFunction={this.onClickliveStreaming}
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                      ) : null}
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.scan_and_pay?.value) ||
                      (this.props.fastFoodDiningService &&
                        this.props.fastFoodDiningData?.scan_and_pay?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.scan_and_pay?.value) ? (
                        <Col md={6}>
                          <Row className="py-2">
                            <Col>
                              <div className="f20-700 mb-4">Scan And Pay</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <Toggle
                                checked={this.state?.scan_And_Pay}
                                toggleFunction={this.onClickScanAndPay}
                                disabled={
                                  this.state.softOnboarding ? true : false
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                      ) : null}

                      <Col md={12}>
                        <hr className="mb-4" />
                      </Col>
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.experience_management
                          ?.value) ||
                      (this.props.fastFoodDiningService &&
                        this.props.fastFoodDiningData?.experience_management
                          ?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.experience_management
                          ?.value) ? (
                        <ExperienceSessionManagement
                          experienceManagementSpecial={
                            this.state?.experienceManagementSpecial
                          }
                          experienceManagementCurated={
                            this.state?.experienceManagementCurated
                          }
                          onClickExperience={this.onClickExperience}
                          disabled={this.state.softOnboarding ? true : false}
                        />
                      ) : null}
                      {/* <Col md={12}>
                        <hr className="mb-4" />
                      </Col>

                      <RunSessionAutomatically
                        sessionAutomateFun={this.sessionAutomateFun}
                        sessionAutomateChange={this.sessionAutomateChange}
                        setTimingsFun={this.setTimingsFun}
                        session_auto={this.state.session_auto}
                        timings={this.state.timings}
                        token={this.props?.auth?.user?.accessToken}
                        getNewData={this.state.getNewData}
                      /> */}
                      <Col md={12}>
                        <hr className="mb-4" />
                      </Col>
                      <Col md={12}>
                        <div className="f20-700 mb-4">
                          Manage Calendar and Reservations
                        </div>
                        <div className="d-flex flex-wrap align-items-center justify-content-between justify-content-md-start justify-content-lg-start justify-content-xl-start">
                          <NavLink
                            to="/manage-block-reservation-calendar"
                            className="f15-500 mobile-f13-500 text-gray enLightGrayBtn mr-md-3 mb-3"
                          >
                            <Image
                              src={require("../../../assets/images/ActionImages/1/ManageReservationBlock.png")}
                              alt="Edit"
                              title="Edit"
                              fluid
                              className="w-20px"
                            />
                            Manage Reservation
                            <br />
                            Block
                          </NavLink>
                          <NavLink
                            to="/managehoursoperation"
                            className="f15-500 mobile-f13-500 text-gray enLightGrayBtn mb-3"
                          >
                            <Image
                              src={require("../../../assets/images/ActionImages/1/ManageHoursOperation.png")}
                              alt="Edit"
                              title="Edit"
                              fluid
                              className="w-20px"
                            />
                            Manage Hours
                            <br />
                            of Operation
                          </NavLink>
                        </div>
                      </Col>
                      <Col md={12}>
                        <hr className="mb-4" />
                      </Col>
                      <Col md={12}>
                        <div className="pb-4 d-flex align-items-center margin-bottom-150px">
                          <Button
                            variant="outline-secondary"
                            className="btn-lg mr-4 px-5 btn150px"
                            onClick={this.onCancelSubmit}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="danger"
                            className={`btn-lg px-5 btn150px ${
                              actionButton === false ? "disabled" : ""
                            }`}
                            onClick={
                              actionButton === false
                                ? null
                                : this.onSubmitHandler
                            }
                          >
                            Save
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Media>

                  <SessionManualCompletion
                    data={this.state.sessionData}
                    onSuccessSeating={this.onSuccessSeating}
                    markAllAsComplete={this.markAllAsComplete}
                    sessionData={
                      this?.state?.sessionData?.run_sessions_automatically
                    }
                  />
                  {/* Mobile settings */}
                  <Media query="(max-width: 991px)">
                    <Row>
                      <Col lg={6}>
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.seating?.walkin_waitlist
                            ?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.seating?.walkin_waitlist
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500">Walk-In / Wait</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <span
                                className={
                                  this.state?.sessionWalkinWaitlist
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.sessionWalkinWaitlist}
                                toggleFunction={
                                  this.onClickSessionWalkinWaitlist
                                }
                              />
                              <span
                                className={
                                  this.state?.sessionWalkinWaitlist
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.seating?.reservation
                            ?.value &&
                          this.props.casualDiningData?.seating?.reservation
                            ?.same_day_reservation) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.seating?.reservation
                            ?.value &&
                          this.props.multiDiningData?.seating?.reservation
                            ?.same_day_reservation) ? (
                          <Row
                            className={`${
                              this.props.cus_busi_overlay_data
                                ?.customerBusinessCount === 2
                                ? "bg-white py-4"
                                : "pb-4"
                            }`}
                          >
                            <Col>
                              <div className="f15-500 pb-1">Reservation</div>
                              <div className="f12-400">
                                Reservations for a later time, today, can be
                                placed by the guest
                              </div>
                            </Col>
                            <Col
                              className="d-flex"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <span
                                className={
                                  this.state?.sessionReservation
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.sessionReservation}
                                toggleFunction={this.onClickSessionReservation}
                              />
                              <span
                                className={
                                  this.state?.sessionReservation
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                      </Col>

                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.seating?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.seating?.value) ? (
                        <Col lg={6}>
                          <div className="f20-700 mb-4">
                            Auto Accept Seating
                          </div>
                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.seating
                              ?.walkin_waitlist?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.seating?.walkin_waitlist
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Walk-In / Wait</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.autoAcceptWalkinWaitlist
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.autoAcceptWalkinWaitlist}
                                  toggleFunction={
                                    this.onClickAutoAcceptWalkinWaitlist
                                  }
                                />
                                <span
                                  className={
                                    this.state?.autoAcceptWalkinWaitlist
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}

                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.seating?.reservation
                              ?.value &&
                            this.props.casualDiningData?.seating?.reservation
                              ?.same_day_reservation) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.seating?.reservation
                              ?.value &&
                            this.props.multiDiningData?.seating?.reservation
                              ?.same_day_reservation) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Reservation</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.autoAcceptReservation
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.autoAcceptReservation}
                                  toggleFunction={
                                    this.onClickAutoAcceptReservation
                                  }
                                />
                                <span
                                  className={
                                    this.state?.autoAcceptReservation
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                        </Col>
                      ) : null}

                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.seating?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.seating?.value) ? (
                        <Col lg={6}>
                          <div className="f20-700 mb-2">
                            Future Seating Activities
                          </div>
                          <p className="f14-400 mb-4 color-gray">
                            In this section you can manage accepting orders from
                            the next day
                          </p>
                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.seating?.reservation
                              ?.value &&
                            this.props.casualDiningData?.seating?.reservation
                              ?.same_day_reservation) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.seating?.reservation
                              ?.value &&
                            this.props.multiDiningData?.seating?.reservation
                              ?.same_day_reservation) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Reservation</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.futureReservation
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.futureReservation}
                                  toggleFunction={
                                    // this.props.subscriptionData?.this.props.subscriptionData.casual_dining_status
                                    (e) =>
                                      this.onClickFutureOrderSettings(
                                        "futureReservation"
                                      )
                                  }
                                />
                                <span
                                  className={
                                    this.state?.futureReservation
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                        </Col>
                      ) : null}

                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.seating?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.seating?.value) ? (
                        <Col md={12}>
                          <hr className="mb-4" />
                        </Col>
                      ) : null}
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.ordering?.value) ||
                      (this.props.fastFoodDiningService &&
                        this.props.fastFoodDiningData?.ordering?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.ordering?.value) ? (
                        <Col lg={6}>
                          <div className="f20-700 mb-4">Order Setting</div>
                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering?.take_away
                              ?.value) ||
                          (this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering?.take_away
                              ?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering?.take_away
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Take Away</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.orderSettingTakeAway
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.orderSettingTakeAway}
                                  toggleFunction={(e) =>
                                    this.onClickOrderSettings("takeAway")
                                  }
                                />
                                <span
                                  className={
                                    this.state?.orderSettingTakeAway
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}

                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering
                              ?.cubside_delivery?.value) ||
                          (this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering
                              ?.cubside_delivery?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering
                              ?.cubside_delivery?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Curbside Delivery</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.orderSettingCurbsideDelivery
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={
                                    this.state?.orderSettingCurbsideDelivery
                                  }
                                  toggleFunction={(e) =>
                                    this.onClickOrderSettings("curbside")
                                  }
                                />
                                <span
                                  className={
                                    this.state?.orderSettingCurbsideDelivery
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering?.dine_in_order
                              ?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering?.dine_in_order
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500 pb-1">
                                  Dine-In / Order Ahead
                                </div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.orderSettingDineIn
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.orderSettingDineIn}
                                  toggleFunction={(e) =>
                                    this.onClickOrderSettings("dinein")
                                  }
                                />
                                <span
                                  className={
                                    this.state?.orderSettingDineIn
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}

                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering
                              ?.catering_banquet?.value) ||
                          (this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering
                              ?.catering_banquet?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering
                              ?.catering_banquet?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Catering</div>
                              </Col>
                              <Col className="d-flex align-items-center">
                                <span
                                  className={
                                    this.state?.orderSettingCatering
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.orderSettingCatering}
                                  toggleFunction={(e) =>
                                    this.onClickOrderSettings("catering")
                                  }
                                />
                                <span
                                  className={
                                    this.state?.orderSettingCatering
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering?.home_delivery
                              ?.value) ||
                          (this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering
                              ?.home_delivery?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering?.home_delivery
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Home Delivery</div>
                              </Col>
                              <Col className="d-flex align-items-center">
                                <span
                                  className={
                                    this.state?.orderSettingHomeDelivery
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.orderSettingHomeDelivery}
                                  toggleFunction={(e) =>
                                    this.onClickOrderSettings("homeDelivery")
                                  }
                                />
                                <span
                                  className={
                                    this.state?.orderSettingHomeDelivery
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                          {(this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering?.self_serve
                              ?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering?.self_serve
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500 pb-1">
                                  Skip the Line
                                </div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.orderSettingSkipTheLine
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.orderSettingSkipTheLine}
                                  toggleFunction={(e) =>
                                    this.onClickOrderSettings("skipline")
                                  }
                                />
                                <span
                                  className={
                                    this.state?.orderSettingSkipTheLine
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                        </Col>
                      ) : null}

                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.ordering?.value) ||
                      (this.props.fastFoodDiningService &&
                        this.props.fastFoodDiningData?.ordering?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.ordering?.value) ? (
                        <Col lg={6}>
                          <div className="f20-700 mb-4">Auto Accept Orders</div>
                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering?.take_away
                              ?.value) ||
                          (this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering?.take_away
                              ?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering?.take_away
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Take Away</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.autoAcceptOrderTakeAway
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.autoAcceptOrderTakeAway}
                                  toggleFunction={(e) =>
                                    this.onClickAutoAcceptOrderSettings(
                                      "takeAway"
                                    )
                                  }
                                />
                                <span
                                  className={
                                    this.state?.autoAcceptOrderTakeAway
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}

                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering
                              ?.cubside_delivery?.value) ||
                          (this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering
                              ?.cubside_delivery?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering
                              ?.cubside_delivery?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Curbside Delivery</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.autoAcceptOrderCurbsideDelivery
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={
                                    this.state?.autoAcceptOrderCurbsideDelivery
                                  }
                                  toggleFunction={(e) =>
                                    this.onClickAutoAcceptOrderSettings(
                                      "curbside"
                                    )
                                  }
                                />
                                <span
                                  className={
                                    this.state?.autoAcceptOrderCurbsideDelivery
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering?.dine_in_order
                              ?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering?.dine_in_order
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500 pb-1">
                                  Dine-In / Order Ahead
                                </div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.autoAcceptOrderDineIn
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.autoAcceptOrderDineIn}
                                  toggleFunction={(e) =>
                                    this.onClickAutoAcceptOrderSettings(
                                      "dinein"
                                    )
                                  }
                                />
                                <span
                                  className={
                                    this.state?.autoAcceptOrderDineIn
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                          {(this.props?.fastFoodDiningService &&
                            this.props?.fastFoodDiningData?.ordering?.self_serve
                              ?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering?.self_serve
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500 pb-1">
                                  Skip the Line
                                </div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.eventAutoAcceptSetting
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.eventAutoAcceptSetting}
                                  toggleFunction={
                                    this.onClickEventAutoAcceptSeating
                                  }
                                />
                                <span
                                  className={
                                    this.state?.eventAutoAcceptSetting
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}

                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering
                              ?.catering_banquet?.value) ||
                          (this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering
                              ?.catering_banquet?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering
                              ?.catering_banquet?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Catering</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.autoAcceptOrderCatering
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={this.state?.autoAcceptOrderCatering}
                                  toggleFunction={(e) =>
                                    this.onClickAutoAcceptOrderSettings(
                                      "catering"
                                    )
                                  }
                                />
                                <span
                                  className={
                                    this.state?.autoAcceptOrderCatering
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                          {(this.props.casualDiningService &&
                            this.props.casualDiningData?.ordering?.home_delivery
                              ?.value) ||
                          (this.props.fastFoodDiningService &&
                            this.props.fastFoodDiningData?.ordering
                              ?.home_delivery?.value) ||
                          (this.props.multiDiningService &&
                            this.props.multiDiningData?.ordering?.home_delivery
                              ?.value) ? (
                            <Row className="pb-4">
                              <Col>
                                <div className="f15-500">Home Delivery</div>
                              </Col>
                              <Col
                                className="d-flex align-items-center"
                                // style={{
                                //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                                // }}
                              >
                                <span
                                  className={
                                    this.state?.autoAcceptOrderHomeDelivery
                                      ? "f12-400 mr-2"
                                      : "f12-500 mr-2"
                                  }
                                >
                                  No
                                </span>
                                <Toggle
                                  checked={
                                    this.state?.autoAcceptOrderHomeDelivery
                                  }
                                  toggleFunction={(e) =>
                                    this.onClickAutoAcceptOrderSettings(
                                      "homeDelivery"
                                    )
                                  }
                                />
                                <span
                                  className={
                                    this.state?.autoAcceptOrderHomeDelivery
                                      ? "f12-500 ml-2"
                                      : "f12-400 ml-2"
                                  }
                                >
                                  Yes
                                </span>
                              </Col>
                            </Row>
                          ) : null}
                        </Col>
                      ) : null}

                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.ordering?.value) ||
                      (this.props.fastFoodDiningService &&
                        this.props.fastFoodDiningData?.ordering?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.ordering?.value) ? (
                        <Col md={12}>
                          <hr className="mb-4" />
                        </Col>
                      ) : null}

                      <Col lg={6}>
                        <div className="f20-700 mb-2">Future Activities</div>
                        <p className="f14-400 mb-4 color-gray">
                          In this section you can manage accepting orders from
                          the next day
                        </p>
                        <Row className="pb-4">
                          <Col>
                            <div className="f15-500">Orders</div>
                          </Col>
                          <Col
                            className="d-flex align-items-center"
                            // style={{
                            //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                            // }}
                          >
                            <span
                              className={
                                this.state?.futureOrders
                                  ? "f12-400 mr-2"
                                  : "f12-500 mr-2"
                              }
                            >
                              No
                            </span>
                            <Toggle
                              checked={this.state?.futureOrders}
                              toggleFunction={
                                (e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureOrders"
                                  )
                                // this.onClickScanAndPay
                              }
                            />
                            <span
                              className={
                                this.state?.futureOrders
                                  ? "f12-500 ml-2"
                                  : "f12-400 ml-2"
                              }
                            >
                              Yes
                            </span>
                          </Col>
                        </Row>
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering?.take_away
                            ?.value) ||
                        (this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering?.take_away
                            ?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.take_away
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500 pb-1 pl-4">Take Away</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <span
                                className={
                                  this.state?.futureTakeAway
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.futureTakeAway}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureTakeAway"
                                  )
                                }
                              />
                              <span
                                className={
                                  this.state?.futureTakeAway
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering
                            ?.cubside_delivery?.value) ||
                        (this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering
                            ?.cubside_delivery?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.cubside_delivery
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500 pb-1 pl-4">
                                Curb Side Delivery
                              </div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <span
                                className={
                                  this.state?.futureCurbSide
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.futureCurbSide}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureCurbSide"
                                  )
                                }
                              />
                              <span
                                className={
                                  this.state?.futureCurbSide
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering?.dine_in_order
                            ?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.dine_in_order
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500 pb-1 pl-4">
                                Dine-In / Order Ahead
                              </div>
                            </Col>
                            <Col className="d-flex align-items-center">
                              <span
                                className={
                                  this.state?.futureDinein
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.futureDinein}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureDinein"
                                  )
                                }
                              />
                              <span
                                className={
                                  this.state?.futureDinein
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props?.fastFoodDiningService &&
                          this.props?.fastFoodDiningData?.ordering?.self_serve
                            ?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.self_serve
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500 pb-1 pl-4">
                                Skip the Line
                              </div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <span
                                className={
                                  this.state?.futureSkipTheLine
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.futureSkipTheLine}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureSkipTheLine"
                                  )
                                }
                              />
                              <span
                                className={
                                  this.state?.futureSkipTheLine
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering
                            ?.catering_banquet?.value) ||
                        (this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering
                            ?.catering_banquet?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.catering_banquet
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500 pb-1 pl-4">Catering</div>
                            </Col>
                            <Col className="d-flex align-items-center">
                              <span
                                className={
                                  this.state?.futureCatering
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.futureCatering}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureCatering"
                                  )
                                }
                              />
                              <span
                                className={
                                  this.state?.futureCatering
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                        {(this.props.casualDiningService &&
                          this.props.casualDiningData?.ordering?.home_delivery
                            ?.value) ||
                        (this.props.fastFoodDiningService &&
                          this.props.fastFoodDiningData?.ordering?.home_delivery
                            ?.value) ||
                        (this.props.multiDiningService &&
                          this.props.multiDiningData?.ordering?.home_delivery
                            ?.value) ? (
                          <Row className="pb-4">
                            <Col>
                              <div className="f15-500 pb-1 pl-4">
                                Home Delivery
                              </div>
                            </Col>
                            <Col className="d-flex align-items-center">
                              <span
                                className={
                                  this.state?.futureHomeDelivery
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.futureHomeDelivery}
                                toggleFunction={(e) =>
                                  this.onClickFutureOrderSettings(
                                    "futureHomeDelivery"
                                  )
                                }
                              />
                              <span
                                className={
                                  this.state?.futureHomeDelivery
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                      </Col>

                      <Col lg={6}></Col>
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.event_management?.value &&
                        this.props.casualDiningData?.event_management
                          ?.offline_event?.value &&
                        this.props.casualDiningData?.event_management
                          ?.offline_event?.rsvp?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.event_management?.value &&
                        this.props.multiDiningData?.event_management
                          ?.offline_event?.value &&
                        this.props.multiDiningData?.event_management
                          ?.offline_event?.rsvp?.value) ? (
                        <Col md={12}>
                          <hr className="mb-4" />
                        </Col>
                      ) : (
                        ""
                      )}
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.event_management?.value &&
                        this.props.casualDiningData?.event_management
                          ?.offline_event?.value &&
                        this.props.casualDiningData?.event_management
                          ?.offline_event?.rsvp?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.event_management?.value &&
                        this.props.multiDiningData?.event_management
                          ?.offline_event?.value &&
                        this.props.multiDiningData?.event_management
                          ?.offline_event?.rsvp?.value) ? (
                        <div className="col-12">
                          <Row>
                            <Col lg={6}>
                              <div className="f20-700 mb-4">
                                Event Session Settings
                              </div>
                              <Row className="pb-4">
                                <Col>
                                  <div className="f15-500">RSVP</div>
                                </Col>
                                <Col
                                  className="d-flex align-items-center"
                                  // style={{
                                  //   opacity: `${
                                  //     customerOverlayPopup ? "0.3" : ""
                                  //   }`,
                                  // }}
                                >
                                  <span
                                    className={
                                      this.state?.eventSessionSettings
                                        ? "f12-400 mr-2"
                                        : "f12-500 mr-2"
                                    }
                                  >
                                    No
                                  </span>
                                  <Toggle
                                    checked={this.state?.eventSessionSettings}
                                    toggleFunction={
                                      this.onClickEventAutoAcceptSession
                                    }
                                  />
                                  <span
                                    className={
                                      this.state?.eventSessionSettings
                                        ? "f12-500 ml-2"
                                        : "f12-400 ml-2"
                                    }
                                  >
                                    Yes
                                  </span>
                                </Col>
                              </Row>
                              {(this.props.casualDiningData?.event_management
                                ?.offline_event?.booking_enabled?.value ||
                                this.props.multiDiningData?.event_management
                                  ?.offline_event?.booking_enabled?.value) && (
                                <Row className="pb-4">
                                  <Col>
                                    <div className="f15-500">
                                      Ticket Booking
                                    </div>
                                  </Col>
                                  <Col className="d-flex align-items-center">
                                    <span
                                      className={
                                        this.state?.eventTicketSession
                                          ? "f12-400 mr-2"
                                          : "f12-500 mr-2"
                                      }
                                    >
                                      No
                                    </span>
                                    <Toggle
                                      checked={this.state?.eventTicketSession}
                                      toggleFunction={
                                        this.onClickTicketAutoAcceptSession
                                      }
                                    />
                                    <span
                                      className={
                                        this.state?.eventTicketSession
                                          ? "f12-500 ml-2"
                                          : "f12-400 ml-2"
                                      }
                                    >
                                      Yes
                                    </span>
                                  </Col>
                                </Row>
                              )}
                            </Col>
                            <Col lg={6}>
                              <div className="f20-700 mb-4">
                                Event Auto Accept Seating
                              </div>
                              {/* {this.props.subscriptionData &&
                            this.props.subscriptionData.casual_dining === true &&
                            this.props.subscriptionData.casual_dining_status.seating
                              .walkin_waitlist.auto_accept.value === true ? ( */}
                              <Row className="pb-4">
                                <Col>
                                  <div className="f15-500">RSVP</div>
                                </Col>
                                <Col
                                  className="d-flex align-items-center"
                                  // style={{
                                  //   opacity: `${
                                  //     customerOverlayPopup ? "0.3" : ""
                                  //   }`,
                                  // }}
                                >
                                  <span
                                    className={
                                      this.state?.eventAutoAcceptSetting
                                        ? "f12-400 mr-2"
                                        : "f12-500 mr-2"
                                    }
                                  >
                                    No
                                  </span>
                                  <Toggle
                                    checked={this.state?.eventAutoAcceptSetting}
                                    toggleFunction={
                                      this.onClickEventAutoAcceptSeating
                                    }
                                  />
                                  <span
                                    className={
                                      this.state?.eventAutoAcceptSetting
                                        ? "f12-500 ml-2"
                                        : "f12-400 ml-2"
                                    }
                                  >
                                    Yes
                                  </span>
                                </Col>
                              </Row>
                              {/* ) : null} */}
                            </Col>
                          </Row>
                        </div>
                      ) : null}
                      <Col md={12}>
                        <hr className="mb-4" />
                      </Col>
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.live_streaming?.value) ||
                      (this.props.fastFoodDiningService &&
                        this.props.fastFoodDiningData?.live_streaming?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.live_streaming?.value) ? (
                        <Col md={6} ref={this.myDivToFocus}>
                          <Row className="py-2">
                            <Col>
                              <div className="f20-700 mb-4">Live Streaming</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <span
                                className={
                                  this.state?.liveStreaming
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.liveStreaming}
                                toggleFunction={
                                  // this.props.subscriptionData?.this.props.subscriptionData.casual_dining_status
                                  this.onClickliveStreaming
                                }
                              />
                              <span
                                className={
                                  this.state?.liveStreaming
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      ) : null}
                      {(this.props.casualDiningService &&
                        this.props.casualDiningData?.scan_and_pay?.value) ||
                      (this.props.fastFoodDiningService &&
                        this.props.fastFoodDiningData?.scan_and_pay?.value) ||
                      (this.props.multiDiningService &&
                        this.props.multiDiningData?.scan_and_pay?.value) ? (
                        <Col md={6}>
                          <Row className="py-2">
                            <Col>
                              <div className="f20-700 mb-4">Scan And Pay</div>
                            </Col>
                            <Col
                              className="d-flex align-items-center"
                              // style={{
                              //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
                              // }}
                            >
                              <span
                                className={
                                  this.state?.scan_And_Pay
                                    ? "f12-400 mr-2"
                                    : "f12-500 mr-2"
                                }
                              >
                                No
                              </span>
                              <Toggle
                                checked={this.state?.scan_And_Pay}
                                toggleFunction={this.onClickScanAndPay}
                              />
                              <span
                                className={
                                  this.state?.scan_And_Pay
                                    ? "f12-500 ml-2"
                                    : "f12-400 ml-2"
                                }
                              >
                                Yes
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      ) : null}
                      {/* <Col md={12}>
                        <hr className="mb-4" />
                      </Col>

                      <RunSessionAutomatically
                        sessionAutomateFun={this.sessionAutomateFun}
                        sessionAutomateChange={this.sessionAutomateChange}
                        setTimingsFun={this.setTimingsFun}
                        session_auto={this.state.session_auto}
                        timings={this.state.timings}
                        token={this.props?.auth?.user?.accessToken}
                        getNewData={this.state.getNewData}
                      /> */}
                      <Col md={12}>
                        <hr className="mb-4" />
                      </Col>
                      <Col md={12}>
                        <div className="f20-700 mb-4">
                          Manage Calendar and Reservations
                        </div>
                        <div className="d-flex flex-wrap align-items-center justify-content-between justify-content-md-start justify-content-lg-start justify-content-xl-start">
                          <NavLink
                            to="/manage-block-reservation-calendar"
                            className="f15-500 mobile-f13-500 text-gray enLightGrayBtn mr-md-3 mb-3"
                          >
                            <Image
                              src={require("../../../assets/images/ActionImages/1/ManageReservationBlock.png")}
                              alt="Edit"
                              title="Edit"
                              fluid
                              className="w-20px"
                            />
                            Manage Reservation
                            <br />
                            Block
                          </NavLink>
                          <NavLink
                            to="/managehoursoperation"
                            className="f15-500 mobile-f13-500 text-gray enLightGrayBtn mb-3"
                          >
                            <Image
                              src={require("../../../assets/images/ActionImages/1/ManageHoursOperation.png")}
                              alt="Edit"
                              title="Edit"
                              fluid
                              className="w-20px"
                            />
                            Manage Hours
                            <br />
                            of Operation
                          </NavLink>
                        </div>
                      </Col>
                      <Col md={12}>
                        <hr className="mb-4" />
                      </Col>
                      <Col md={12}>
                        <div className="pb-4 d-flex align-items-center margin-bottom-150px">
                          <Button
                            variant="outline-secondary"
                            className="btn-lg mr-4 px-5 btn150px"
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="danger"
                            className={`btn-lg px-5 btn150px ${
                              actionButton === false ? "disabled" : ""
                            }`}
                            onClick={
                              actionButton === false
                                ? null
                                : this.onSubmitHandler
                            }
                          >
                            Save
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Media>
                </div>
              </div>
              <Media query="(max-width: 991px)">
                <div className="bottom-panel">
                  <BottomNavigationMobile />
                </div>
              </Media>
            </Row>
          </Container>
          <Modal
            show={this.state.openErrorModal}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            onHide={this.handleShowclose}
          >
            <Modal.Header className="border-0" closeButton>
              <Modal.Title>Error</Modal.Title>
            </Modal.Header>
            <Modal.Body className="f14-500">
              To enable any of the services from session settings please
              maintain bank details first.
            </Modal.Body>
            <Modal.Footer className="border-0"></Modal.Footer>
          </Modal>
        </React.Fragment>
      );
    } catch (e) {
      console.log(e);
    }
  }
}

CustomersBusiness.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state?.errors && state?.errors?.errors,
  customerBusinessOverlayData: state?.auth?.user?.VendorUser?.overlay_intro,
  cus_busi_overlay_data: state?.overlayScreens?.customerBusiness,
  onboarding: state?.onboarding && state?.onboarding?.restaurantDetails,
  subscriptionData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,

  /********* Casual Dining service *********/
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  casualDiningData:
    state?.onboarding?.onboard_subscription_details?.casual_dining_status,

  /********* Fast Food Dining service *********/
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  fastFoodDiningData:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining_status,

  /********* Multi Dining service *********/
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  multiDiningData:
    state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status,

  deliveryPartner:
    state?.onboarding?.onboard_subscription_details?.delivery_partner,

  subscriptionStatus: state?.onboarding?.onboard_subscription_details
    ?.casual_dining
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
    : state?.onboarding?.onboard_subscription_details?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status
    : {},
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
  vendo_session_settings,
  get_notification_count,
})(withRouter(CustomersBusiness));

const SessionManualCompletion = (props) => {
  const [open, setOpen] = useState(false);
  const setOpenTrue = () => setOpen(true);
  const setOpenFalse = () => setOpen(false);

  const [state, setState] = useState(0);

  useEffect(() => {
    if (
      props?.sessionData === false &&
      (props?.data?.seating?.length > 0 || props?.data?.ordering?.length > 0)
    ) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [props?.sessionData]);

  return (
    <div>
      <Modal
        show={open}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        backdrop="static"
        onHide={setOpenFalse}
      >
        <Modal.Header className="border-0" closeButton>
          <Modal.Title>Attention Required_Complete Below Requests</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f14-500">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div
                className={`${
                  state === 0 ? `text-red f12-700` : `f12-400`
                } mr-3`}
                onClick={() => setState(0)}
                style={{
                  cursor: "pointer",
                  borderBottom: state === 0 ? "3px solid #ee3a23" : "none",
                }}
              >
                {" "}
                Seating{" "}
              </div>
              <div
                className={`${
                  state === 1 ? `text-red f12-700` : `f12-400`
                } mr-3`}
                onClick={() => setState(1)}
                style={{
                  cursor: "pointer",
                  borderBottom: state === 1 ? "3px solid #ee3a23" : "none",
                }}
              >
                {" "}
                Ordering{" "}
              </div>
              <div
                className={`${
                  state === 2 ? `text-red f12-700` : `f12-400`
                } mr-3`}
                onClick={() => setState(2)}
                style={{
                  cursor: "pointer",
                  borderBottom: state === 2 ? "3px solid #ee3a23" : "none",
                }}
              >
                {" "}
                Events{" "}
              </div>
            </div>
            <div
              className="d-flex align-items-center "
              style={{ cursor: "pointer" }}
              onClick={() => props.markAllAsComplete(state)}
            >
              <Image
                fluid
                width="25px"
                src={require("../../../assets/images/AuthImages/checked.png")}
                alt="Checked"
                title="All Record"
                className="checked-images mr-3"
              />
              <p> Mark all as complete</p>
            </div>
          </div>
          <hr className="mt-0 mb-3" />
          <div>
            {state === 0 && (
              <div className="main-seating-dashboard-body">
                <div className="col-12 seating-dashboard-body-width">
                  <div>
                    <Table>
                      <thead className="seating-dashboard-desktop-table">
                        <TableHeadSeating />
                      </thead>
                      {props?.data?.seating?.map((data, index) => (
                        <TableBodySeating
                          key={index}
                          dinerInfo={data}
                          onSuccess={props.onSuccessSeating}
                        />
                      ))}
                    </Table>
                  </div>
                </div>
              </div>
            )}
            {state === 1 && (
              <div className="col-12">
                <div className="col-12 p-0  user-table-reusable-superadmin font_16_r">
                  <Table>
                    <thead>
                      <TableHeadOrdering />
                    </thead>
                    {props?.data?.ordering?.map((data, index) => (
                      <TableBodyOrdering
                        orderDetails={data}
                        key={index}
                        // onUpdateOrderStatus={(formData) =>
                        //   onUpdateOrderStatus(formData)
                        // }
                        // getUpdatedData={() => getUpdatedData()}
                      />
                    ))}
                  </Table>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0"></Modal.Footer>
      </Modal>
    </div>
  );
};

const RunSessionAutomatically = (props) => {
  const sessionAutomateFun = (e) => props.sessionAutomateChange();
  const setTimingsFun = (e) => {
    let sendTime = moment(
      new Date().setHours(
        parseInt(e.split(":")[0]) - 5,
        parseInt(e.split(":")[1]) - 30
      )
    ).format("HH:mm");
    props.setTimingsFun(e, sendTime);
  };

  useEffect(() => {
    const token = props?.token;
    get_session_automate(token, (data) => {
      props.sessionAutomateFun(data.run_sessions_automatically, data);
    });
  }, [props.getNewData]);
  return (
    <Col md={12}>
      <div className="f20-700 ">Mass Completion</div>
      <div className="f12-400 mb-4">
        Manage Session for mass completion of
        <br /> Seating/Ordering requests
      </div>
      <div className="row">
        <div className="col-md-3 col-6 f20-700 ">
          Run Sessions Automatically
        </div>
        <Col
          className="d-flex align-items-center"
          xs={6}
          // style={{
          //   opacity: `${customerOverlayPopup ? "0.3" : ""}`,
          // }}
        >
          <span
            className={props.session_auto ? "f12-400 mr-2" : "f12-500 mr-2"}
          >
            No
          </span>
          <Toggle
            checked={props.session_auto}
            toggleFunction={
              // this.props.subscriptionData?.this.props.subscriptionData.casual_dining_status
              sessionAutomateFun
            }
          />
          <span
            className={props.session_auto ? "f12-500 ml-2" : "f12-400 ml-2"}
          >
            Yes
          </span>
        </Col>
      </div>
      <div className="f12-400 mb-4">
        All the Seating/Ordering/Events <br />
        requests will be mass completed
        <br /> automatically at a given time.
      </div>
      {props.session_auto && (
        <div className="d-flex align-items-center">
          <div className="f12-500 mr-3">Suggestive Time</div>
          <div className="col-7 col-md-2">
            <FormControl variant="outlined" className={`w-100`}>
              <InputLabel id="timings">Time</InputLabel>
              <Select
                id="timings"
                label="Timings"
                labelId="timings"
                name="timings"
                value={props.timings}
                onChange={(e) => setTimingsFun(e.target.value)}
              >
                {Hours_24.map((data, index) => (
                  <MenuItem key={index} value={`${data}`}>
                    {data}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      )}
    </Col>
  );
};
